
import React ,{ Component } from 'react';
import {Container, Row, Col,Image,Button,Form,Card,InputGroup,Collapse  } from 'react-bootstrap';
import "./cadreRegistration.css";
import { withRouter,Link } from "react-router-dom";
import SelectBox from '../SelectDropDown/SelectDropDown';
import { components } from 'react-select';
import loader from '../../images/loader.gif';
import Membership_logo from '../../images/membership.jpg';
import CardLessDataTableWithSearchLimit10 from '../datatables/CardLessDataTableWithSearchLimit10';
import { getAPICallData } from '../../services/MemberService'
import { getAPICallDataForOnlyBSA } from '../../services/MemberService';
import { getAPICallDataForCadre } from '../../services/MemberService';
import { getAPICallDataForCadreSaving } from '../../services/MemberService';
import { getAPICallDataForPayment } from '../../services/MemberService';
import jwt_decode from "jwt-decode";
import CapturePhotoForEnroll from "./CapturePhotoForEnroll";
import DisplayCardDetails from "./DisplayCardDetails";
import { scroller } from "react-scroll";
import ChangeMobileNoOTPValidation from './ChangeMobileNoOTPValidation';
import DonationAmount from './DonationAmount';
import PaymentOptionMode from './PaymentOptionMode';
import CardselectedType from './CardselectedType';
import axios from 'axios'

//const fetch = require('node-fetch');

const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
  };

class CadreRegistrationGeneralSection extends Component {
    constructor(props) {
        super(props)
        

        this.state = {
            webcamRef : React.createRef(),
            chatID: window.User !=undefined ? window.User.chatID : "943827154",
            //userAccessList:props?.location?.params?.userAccessList == undefined ? "" : props?.location?.params?.userAccessList,
            isVolunteerReloadCheck:props?.location?.params?.isVolunteerReloadCheck == undefined ? "" : props?.location?.params?.isVolunteerReloadCheck,
            
            enrollType:"newEnroll",
            renewalDetailsLoading:"hide",
            renewalDetailsArr:[],
            renewalDetailsDataCheck:0,

            newEnrollFirstPage:true,
            newEnrollSecondPage:false,


            searchRenewalMembershipId:"",
            searchRenewalMobileNo:"",
            searchRenewalVoterId:"",
            userDetailsError:"",
            
            haveVoterIdCheck:false,
            noVoterIdCheck:false,

            ap_listArr:[],
            constituencyValue:"",
            constituencyName:"",

            mandalLoadingSymbol:"hide",
            mandalValue:"",
            mandalName:"",
            mc_listArr:[],

            genderListArr:[{'value':'M','label':'Male'},{'value':"F",'label':'Female'}],
            genderValue:"",
            genderName:"",

            voterSearchName:"",

            familyVoterIdSearch:"",
            validateFamilyVoterIdSearch:"",
            familyVoterSearchLoading:"hide",
            familyVoterSearchObj:"",
            familyVoterSearchDataCheck:0,

            familyVoterIdName:"",
			familyVoterIdAge:"",
			familyVoterIdGenderArr:[{'value':'M','label':'Male'},{'value':"F",'label':'Female'}],
            familyVoterIdGenderValue:"",
            familyVoterIdGender:"",
            validatePersonDetails:"",

            
            newRegistrationInputObj:{},
            voterIdForNewEnroll:"",
            voterIdSearchVoterCardNo:"",
            voterIdSearchLoadingSymbol:"hide",
            voterIdSearchDetailsObj:{},
            voterIdSearchDataCheck:0,
            validateVoterIdSearch:"",


            familyDetailsLoading:"hide",
            familyDetailsArr:[],
            familyDetailsDataCheck:0,
            familyDetailsOpenBlock:true,

            caste_ids_Arr:[{'value':228, 'label':'Aandh '},{'value':326, 'label':'AASADULA '},
                {'value':75, 'label':'Achukuntla Vandlu '},{'value':312, 'label':'Adi Dravida '},{'value':224, 'label':'AdiAndhra '},{'value':461, 'label':'Agamudayar '},{'value':309, 'label':'Agamudi Mudaliar '},{'value':121, 'label':'Agaru '},{'value':1, 'label':'Agnikula kshathriya '},{'value':199, 'label':'Anamakh '},{'value':200, 'label':'Andhravida '},{'value':122, 'label':'Arae '},{'value':388, 'label':'Arakalies and Surabi natakalavallu '},
                {'value':201, 'label':'Arapamala '},{'value':347, 'label':'Arava '},{'value':387, 'label':'Are Marathi '},{'value':123, 'label':'Arekatika '},
                {'value':202, 'label':'Aremala '},{'value':177, 'label':'Arundatheeya '},{'value':329, 'label':'Arwa Mala '},{'value':76, 'label':'Arya Kshathrya '},{'value':124, 'label':'Atagara '},{'value':397, 'label':'Atirasa '},{'value':77, 'label':'Avusala '},
                {'value':396, 'label':'Ayyaraka '},{'value':2, 'label':'Badar '},{'value':229, 'label':'Bagatha '},{'value':3, 'label':'Balasanthu '},{'value':296, 'label':'Balija '},{'value':467, 'label':'Balija Kapu '},{'value':4, 'label':'Banda '},{'value':5, 'label':'Bandara '},{'value':353, 'label':'Banjara '},{'value':230, 'label':'Barhika Duliya '},{'value':203, 'label':'Barigi '},{'value':125, 'label':'Batraju '},{'value':162, 'label':'Bavuri '},
                {'value':120, 'label':'BC - C (Cristians) '},{'value':178, 'label':'Bedajangam '},{'value':204, 'label':'Begara '},{'value':442, 'label':'Behar '},{'value':179, 'label':'Bendla '},
                {'value':449, 'label':'Bengali '},{'value':342, 'label':'Beri Sheety '},{'value':6, 'label':'Bestha '},{'value':391, 'label':'Bhadbhunja '},{'value':7, 'label':'Bhahurupi '},{'value':390, 'label':'Bhunjwa '},{'value':8, 'label':'Bikshaka Vruthi '},{'value':439, 'label':'Biksham Gunta '},{'value':231, 'label':'Bil '},{'value':403, 'label':'Bindla '},{'value':331, 'label':'Binedu '},{'value':416, 'label':'Bodo Gadaba '},{'value':306, 'label':'Bondili '},{'value':293, 'label':'Boya '},{'value':284, 'label':'Brahmin '},{'value':9, 'label':'Buda Bukkala '},{'value':180, 'label':'Budaga Jangam '},{'value':389, 'label':'Budubunjala '},{'value':126, 'label':'Bukka '},{'value':354, 'label':'Bukka Ayyavara '},{'value':404, 'label':'Byagara '},{'value':405, 'label':'Chachati '},{'value':444, 'label':'Chacherlu '},{'value':406, 'label':'Chalavadi '},{'value':205, 'label':'Challavadi '},{'value':181, 'label':'Chamar '},{'value':182, 'label':'Chambar '},{'value':410, 'label':'Chanchandi '},{'value':164, 'label':'Chandala '},{'value':163, 'label':'Chavati '},{'value':232, 'label':'Chenchu Varu '},{'value':233, 'label':'Chenchumuni '},{'value':127, 'label':'Chimpollu '},{'value':78, 'label':'Chithari '},
                {'value':79, 'label':'Chithrakara '},{'value':445, 'label':'Chitti Karanam '},{'value':11, 'label':'Chopamali '},{'value':459, 'label':'Christian '},{'value':470, 'label':'Converted Harijans '},{'value':183, 'label':'Dakkal/Dakkala Varu '},{'value':355, 'label':'Damala '},{'value':165, 'label':'Dandasi '},{'value':12, 'label':'Dasari (BC-A) '},{'value':128, 'label':'Dasari (BC-D) '},{'value':234, 'label':'Deseeya kondulu '},{'value':235, 'label':'Desiya Dondulu '},{'value':80, 'label':'Devanga '},{'value':13, 'label':'Devara Vandlu '},{'value':184, 'label':'Dhor '},{'value':423, 'label':'Dhulia '},{'value':167, 'label':'DomDombara '},{'value':14, 'label':'Dommara '},{'value':236, 'label':'Dondra Kodulu '},{'value':81, 'label':'Dudekula '},{'value':82, 'label':'Ediga '},{'value':321, 'label':'EKILA '},{'value':352, 'label':'Ekiri '},{'value':15, 'label':'Ellamma Vandlu '},{'value':16, 'label':'Ellasi '},{'value':345, 'label':'Erla '},{'value':237, 'label':'Gadabalu '},{'value':415, 'label':'Gadabas '},{'value':129, 'label':'Gadava '},{'value':318, 'label':'Gajula Balija '},{'value':83, 'label':'Gamalla Kalali '},{'value':84, 'label':'Gandla '},{'value':18, 'label':'Ganga Varu '},{'value':17, 'label':'Gangaputhra '},{'value':19, 'label':'Gangireddu Varu '},{'value':340, 'label':'Ganuga Sheety '},{'value':168, 'label':'Gasi '},{'value':130, 'label':'Gavara '},{'value':407, 'label':'Ghasi '},{'value':131, 'label':'Ginghar '},{'value':85, 'label':'Giniyar '},{'value':170, 'label':'Godagali '},{'value':185, 'label':'Godari '},{'value':20, 'label':'Gondlu '},{'value':238, 'label':'Gondu '},{'value':206, 'label':'Gosam '},{'value':411, 'label':'Gosangi '},{'value':357, 'label':'Gotrala '},{'value':239, 'label':'Goud-ST '},{'value':86, 'label':'Gouda '},{'value':240, 'label':'Goudh '},{'value':87, 'label':'Goundla '},{'value':21, 'label':'Gudala '},{'value':392, 'label':'Gudia '},{'value':393, 'label':'Gudiya '},{'value':417, 'label':'Gutob Gadaba '},{'value':408, 'label':'Haddi '},
                {'value':169, 'label':'Haddi (or) Relli chachandi '},{'value':446, 'label':'Harijans '},{'value':132, 'label':'Hatkhar '},{'value':419, 'label':'Hill Reddis '},{'value':207, 'label':'Huleya '},{'value':208, 'label':'Huleya Dasari '},{'value':186, 'label':'Jaggali '},{'value':412, 'label':'JaJnbllvulu '},{'value':332, 'label':'Jakkula '},{'value':22, 'label':'Jalari '},
                {'value':187, 'label':'Jambavulu '},{'value':88, 'label':'Jandra '},{'value':23, 'label':'Jangam '},{'value':241, 'label':'Jathapass '},{'value':24, 'label':'Jogi '},{'value':341, 'label':'Jogula '},{'value':25, 'label':'Joshinandala Bala '},{'value':133, 'label':'Kachi '},{'value':26, 'label':'Kaikadi '},{'value':89, 'label':'Kaikala '},{'value':438, 'label':'Kaitha Lambadi(Labhana) '},
                {'value':134, 'label':'Kakkana '},{'value':335, 'label':'Kalai Balija '},{'value':135, 'label':'Kalavanthulu Ganika '},{'value':324, 'label':'KALINGA '},{'value':440, 'label':'Kalinga Vysya '},{'value':418, 'label':'kallayi gadaba '},{'value':27, 'label':'Kalli Kapu '},{'value':290, 'label':'Kamma '},{'value':90, 'label':'Kammara (BC) '},{'value':242, 'label':'Kammara (ST) '},{'value':91, 'label':'Kamsali/Vishva Bramhana '},{'value':92, 'label':'Kanchra '},{'value':136, 'label':'Kandhra '},{'value':28, 'label':'Kanjara Battu '},{'value':288, 'label':'Kapu '},{'value':466, 'label':'Kapu Kapu '},{'value':469, 'label':'Kapu-ST '},{'value':304, 'label':'KARANAM '},{'value':323, 'label':'KARIKALABHAKTHULA '},{'value':93, 'label':'Karna Bakthulu '},{'value':322, 'label':'KARNABHAKTHULA '},{'value':358, 'label':'Kasikapadi '},{'value':94, 'label':'Kathri '},{'value':29, 'label':'Kati Papala '},{'value':243, 'label':'Katunaikan '},{'value':333, 'label':'Kavali '},{'value':431, 'label':'Kerala '},{'value':359, 'label':'Keuta '},{'value':360, 'label':'Keviti '},{'value':361, 'label':'Kevuto '},{'value':30, 'label':'Kinthala Kalinga '},{'value':31, 'label':'Kirathaka '},{'value':244, 'label':'Kodhu '},{'value':245, 'label':'Kodi '},{'value':420, 'label':'Kolam '},{'value':421, 'label':'Kolawar '},{'value':188, 'label':'Koluvula Vandlu '},{'value':32, 'label':'Kompara/Reddika '},{'value':246, 'label':'Konda Doralu '},{'value':247, 'label':'Konda Kapulu '},{'value':248, 'label':'Konda Reddlu '},{'value':250, 'label':'Kondlu '},{'value':137, 'label':'Koppula Velama '},{'value':251, 'label':'Koputiya '},{'value':252, 'label':'Koram '},{'value':33, 'label':'Korcha '},{'value':138, 'label':'Kosti '},{'value':433, 'label':'Kotiya '},{'value':253, 'label':'Kotiya Benthu '},{'value':254, 'label':'Koya '},{'value':139, 'label':'Krushna Balija '},{'value':34, 'label':'Kshathriya (BC) '},{'value':291, 'label':'Kshatriya (OC) '},{'value':255, 'label':'Kuliya '},{'value':256, 'label':'Kulwalapai '},{'value':95, 'label':'Kummara '},{'value':35, 'label':'Kunapuli '},{'value':429, 'label':'Kunkuma '},{'value':475, 'label':'Kuraba '},{'value':362, 'label':'Kurakala '},{'value':382, 'label':'Kurni '},
                {'value':96, 'label':'Kuruma '},{'value':257, 'label':'Kuttiya Kodulu '},{'value':317, 'label':'Labbai '},{'value':97, 'label':'Laddaf '},{'value':402, 'label':'Lakkamari Kapu '},{'value':363, 'label':'Lambada '},{'value':258, 'label':'Lambadi '},{'value':313, 'label':'Lingayat '},{'value':384, 'label':'Lodh '},{'value':386, 'label':'Lodha '},{'value':385, 'label':'Lodhi '},{'value':189, 'label':'Madiga '},{'value':190, 'label':'Madiga Dasu '},{'value':209, 'label':'Madisi Kuruva/Madaari Kuruva '},{'value':210, 'label':'Mahar '},{'value':36, 'label':'Mahathar '},{'value':211, 'label':'Mala '},{'value':212, 'label':'Mala Dasari '},{'value':213, 'label':'Mala Hannai '},{'value':214, 'label':'Mala Jangam '},{'value':216, 'label':'Mala Masthi '},{'value':217, 'label':'Mala Sala '},{'value':218, 'label':'Mala sanyasi '},{'value':427, 'label':'Maladasu '},{'value':140, 'label':'Mali '},{'value':259, 'label':'Malin '},{'value':37, 'label':'Mandala (BC) '},{'value':219, 'label':'Mandala (SC) '},{'value':364, 'label':'Mandula '},{'value':191, 'label':'Mang Garodi '},{'value':192, 'label':'Manga '},{'value':260, 'label':'Manna Dora '},{'value':220, 'label':'Manne '},{'value':448, 'label':'Mannepu '},{'value':261, 'label':'Mannevaru '},{'value':315, 'label':'MARATI '},{'value':330, 'label':'MARWADI '},{'value':225, 'label':'Masthi '},{'value':193, 'label':'Masthima '},{'value':194, 'label':'Mathangi '},{'value':262, 'label':'Mathaya Vavaras (or) Kuttu Vavaras '},{'value':141, 'label':'Mathula '},{'value':305, 'label':'MAYDARA '},{'value':39, 'label':'Medari '},{'value':171, 'label':'Mehthar '},{'value':319, 'label':'Mera Darji '},{'value':226, 'label':'Mitha Iyala Varu '},{'value':195, 'label':'Mochi '},{'value':301, 'label':'Mohamad '},{'value':40, 'label':'Mondi Banda '},{'value':41, 'label':'Mondi Varu '},{'value':42, 'label':'Mondipatta '},{'value':196, 'label':'Moochi '},{'value':98, 'label':'Muchi '},{'value':460, 'label':'Mudaliar '},{'value':143, 'label':'Mudhiraj '},{'value':263, 'label':'Muka Dora '},{'value':314, 'label':'MUNDALA '},{'value':144, 'label':'Munnoor Kapu '},{'value':292, 'label':'Muslim '},{'value':145, 'label':'Mutharasi '},{'value':43, 'label':'Muthyalamma Vandlu '},{'value':428, 'label':'Myralu '},{'value':451, 'label':'N/A '},{'value':348, 'label':'Nadar '},{'value':435, 'label':'Nagaralu '},{'value':99, 'label':'Nagavaddilu '},{'value':146, 'label':'Nagavamsha '},{'value':147, 'label':'Nagavasam '},{'value':264, 'label':'Naik '},{'value':265, 'label':'Naikpoth '},{'value':100, 'label':'Nakhan '},{'value':44, 'label':'Nakkala '},{'value':349, 'label':'Nambi '},
                {'value':45, 'label':'Nashadi '},{'value':101, 'label':'Nashni/Kurni '},{'value':307, 'label':'Natari '},{'value':426, 'label':'Nayaka '},{'value':344, 'label':'Nayani Varu '},{'value':365, 'label':'Nayanivaru '},{'value':38, 'label':'Nayee Brahmin '},{'value':47, 'label':'Nayyala '},{'value':102, 'label':'Neelikanti '},{'value':148, 'label':'Nelli '},{'value':325, 'label':'NEPALI '},{'value':48, 'label':'Nera Pravruthi Kalavaru '},{'value':49, 'label':'Nershakari '},{'value':381, 'label':'Nessi '},{'value':447, 'label':'Nethekani '},{'value':50, 'label':'Nokkara '},{'value':432, 'label':'Nooka Dora '},{'value':298, 'label':'Oreganti Reddy '},{'value':458, 'label':'OTHERS '},{'value':472, 'label':'OTHERS-BC '},{'value':471, 'label':'OTHERS-OC '},{'value':473, 'label':'OTHERS-SC '},{'value':474, 'label':'OTHERS-ST '},{'value':103, 'label':'Padmashali '},{'value':166, 'label':'Paidi/pano '},
                {'value':424, 'label':'Paiko '},{'value':172, 'label':'Paki (or) Mothi '},{'value':366, 'label':'Pala Ekari '},{'value':367, 'label':'Palegaru '},{'value':300, 'label':'Pallepu Kapu '},{'value':310, 'label':'Palli '},{'value':343, 'label':'Palli Kapu '},{'value':346, 'label':'Palli Reddy '},{'value':51, 'label':'Pambala '},{'value':174, 'label':'Pamidi '},{'value':52, 'label':'Pamula '},{'value':227, 'label':'Panchama (or) Pariyuhi '},{'value':450, 'label':'Panda '},{'value':150, 'label':'Panjari '},{'value':53, 'label':'Pannari '},{'value':266, 'label':'Parangi Parcha '},{'value':422, 'label':'Pardhan '},{'value':54, 'label':'Parthi '},{'value':151, 'label':'Paspi '},{'value':395, 'label':'Passi '},{'value':303, 'label':'Pathan '},{'value':104, 'label':'Patkhar '},{'value':55, 'label':'Patlavu '},{'value':436, 'label':'Patnayak '},{'value':434, 'label':'Patnayak '},{'value':316, 'label':'PATRA '},{'value':299, 'label':'Pattapu '},{'value':454, 'label':'Pattusali '},{'value':56, 'label':'Peddaboya '},{'value':57, 'label':'Peddama Vandlu '},{'value':105, 'label':'Perika '},{'value':106, 'label':'Perika Balija '},{'value':107, 'label':'Pinjari/Noorbash '},{'value':59, 'label':'Piriki Muggula '},{'value':58, 'label':'Pitchiguntla '},{'value':152, 'label':'Polinati Velama '},{'value':368, 'label':'Pondara '},{'value':153, 'label':'Poosala '},{'value':369, 'label':'Poosala '},{'value':267, 'label':'Porja '},{'value':60, 'label':'Porvam Bikshaka Vruthi '},{'value':462, 'label':'Pusala '},{'value':425, 'label':'Putiya '},{'value':61, 'label':'Rajaka '},{'value':370, 'label':'Rajannala '},{'value':334, 'label':'Rajput '},{'value':289, 'label':'Raju '},{'value':268, 'label':'Rajugondu '},{'value':154, 'label':'Rangaraju/Bhavasara Kshatriya '},
                {'value':441, 'label':'Ravula '},{'value':285, 'label':'Reddy '},{'value':269, 'label':'Reddy Dora '},{'value':465, 'label':'Reddy Kapu '},{'value':468, 'label':'Reddy Reddy '},{'value':175, 'label':'Relli '},{'value':270, 'label':'Rona Rena '},{'value':443, 'label':'Sabeerlu '},{'value':452, 'label':'Sadara '},{'value':155, 'label':'Sadushetti '},{'value':371, 'label':'Saikalgar '},{'value':108, 'label':'Sakulasali '},{'value':197, 'label':'Samagara '},{'value':372, 'label':'Samanthula '},{'value':221, 'label':'Samband '},{'value':222, 'label':'Sambas '},{'value':271, 'label':'Sandrona '},{'value':109, 'label':'Sangundam '},{'value':176, 'label':'Sapru '},{'value':272, 'label':'Sardhan '},{'value':156, 'label':'Sathani '},{'value':273, 'label':'Savaras Kapusavaras '},{'value':311, 'label':'Seervi '},{'value':110, 'label':'Settibalija '},{'value':111, 'label':'Shilpi '},{'value':373, 'label':'Siddula '},{'value':274, 'label':'Sidopaiko '},{'value':430, 'label':'Sikh '},{'value':374, 'label':'Sikligar '},{'value':383, 'label':'Silpis viswakarma '},{'value':198, 'label':'Sindollu '},{'value':351, 'label':'Singh '},{'value':401, 'label':'Sistakaranam '},{'value':398, 'label':'sondi '},{'value':375, 'label':'Sountia '},{'value':112, 'label':'Sri Sayan '},{'value':275, 'label':'Sugaleelu '},{'value':399, 'label':'sundi '},{'value':394, 'label':'Surya Balija '},{'value':339, 'label':'Suryavamsha Rajulu '},{'value':302, 'label':'Syed '},{'value':328, 'label':'Telaga '},{'value':350, 'label':'Telikula '},{'value':113, 'label':'Telugu Matlade Varu '},{'value':114, 'label':'Thalikula '},{'value':157, 'label':'Thammali '},{'value':158, 'label':'Thenugollu '},{'value':276, 'label':'Thikakariya Kodulu '},{'value':115, 'label':'Thogati Thogata '},{'value':173, 'label':'Thoti (BC) '},{'value':277, 'label':'Thoti (ST) '},{'value':159, 'label':'Thurapu Kapu/Gajula Kapu '},{'value':376, 'label':'Tolagari '},{'value':160, 'label':'Uppara/Sankara '},{'value':338, 'label':'Uppu vadde '},{'value':377, 'label':'Vadabalija '},{'value':283, 'label':'Vaddera '},{'value':62, 'label':'Vaddi '},{'value':63, 'label':'Vaddolu '},{'value':116, 'label':'Vadla '},{'value':117, 'label':'Vadra '},{'value':118, 'label':'Vadrangi '},{'value':64, 'label':'Valli '},{'value':65, 'label':'Valli Reddy '},{'value':414, 'label':'Valluvan '},{'value':278, 'label':'Valmiki '},{'value':378, 'label':'Valmiki '},{'value':66, 'label':'Valmiki Boya '},{'value':455, 'label':'Vamsharaj '},{'value':437, 'label':'Vanjari '},{'value':67, 'label':'Vanne Kapu '},{'value':68, 'label':'Vanne Reddy '},{'value':336, 'label':'Vannekapu '},{'value':308, 'label':'Vanyakulakshatriya '},{'value':400, 'label':'varala '},{'value':69, 'label':'Vatti Kothala '},{'value':70, 'label':'Vedabaliga '},
                {'value':379, 'label':'Veerabhadreeya '},{'value':327, 'label':'Veerashaiva LingayatLingabalija '},{'value':287, 'label':'Velama '},{'value':71, 'label':'Venka Kula '},{'value':72, 'label':'Vera Musti '},{'value':73, 'label':'Vodde Yeddelu '},{'value':453, 'label':'Vokkaliga '},{'value':279, 'label':'Voriya/bentu Voriya '},{'value':380, 'label':'Vyakula '},{'value':286, 'label':'Vysya '},{'value':161, 'label':'Yadava '},{'value':337, 'label':'Yalam Reddy '},{'value':74, 'label':'Yata '},{'value':413, 'label':'Yatala '},{'value':223, 'label':'Yellimal Varu '},{'value':280, 'label':'Yenadi '},{'value':281, 'label':'Yerukala '},{'value':282, 'label':'Yoniti Kodulu'}],
        casteIdStr:"",
        casteIdStrValue:"",

        occupationStrValue:"",
        occupationListArr:[{'value':'1','label':'Farmer'},{'value':'2','label':'Handicrafts'},{'value':'3','label':'Business'}
        ,{'value':'4','label':'Industrialist'},{'value':'5','label':'Management'},{'value':'6','label':'Doctor'}
        ,{'value':'7','label':'Lawyer'},{'value':'10','label':'Teacher'},{'value':'12','label':'House Wife'}
        ,{'value':'13','label':'Daily Labour'},{'value':'15','label':'Others'},{'value':'36','label':'IT Industry'}
        ,{'value':'40','label':'Media Person'},{'value':'48','label':'Retailing'},{'value':'54','label':'Govt Employee'}
        ,{'value':'55','label':'Private Employee'},{'value':'56','label':'Student'},{'value':'57','label':'Politician'}
        ,{'value':'58','label':'Self-Employed'},{'value':'60','label':'Proffessional'},{'value':'61','label':'Retd Employee'}
        ,{'value':'62','label':'Skilled Labour'},{'value':'63','label':'Unemployed'},{'value':'65','label':'Agriculture'}
        ,{'value':'66','label':'Dont Know'}],
        occupationStr:"",

        educationStrValue:"",
        educationListArr:[{'value':'1','label':'Un Educated'},{'value':'2','label':'Below X Class'},{'value':'3','label':'X/Inter/Diploma'}
        ,{'value':'4','label':'Graduation'},{'value':'5','label':'Professional Degree'},{'value':'6','label':'Post Graduation'}
        ,{'value':'7','label':'Doctorate'},{'value':'8','label':'Not Applicable'},{'value':'9','label':'Dont Know'}],
        educationStr:"",


        captureMobileNo:"",
        validateCaptureMobileNo:"",
        captureOTPNO:"",
        validateCaptureOTP:"",

        mobileNoDisabled:false,
        otpBlockShow:false,

        smsSentMessage:"",
        otpVerifiedMessageStatus:"",
        otpLoadingSymbol:"hide",
        getOTPLoadingSymbol:"hide",
        OTPSentStatus:"",
        resendOTPLoadingSymbol:"hide",
        resendSmsSentMessage:"",

       
        
        minutes:1,
        seconds:0,
        OTPVerifiedDisabledButton:true,

        familyNomineeSelectedBlock:true,
        addNewNomineeSelectedBlock:false,
        useAsSameNomineeBlock:false,

        relationListArray:[{'value':'1','label':'Father'},{'value':'2','label':'Mother'},{'value':'3','label':'Wife'}
            ,{'value':'4','label':'Brother'},{'value':'5','label':'Sister'},{'value':'7','label':'Husband'}
            ,{'value':'8','label':'Son'},{'value':'9','label':'Daughter'},{'value':'10','label':'Grand Son'}
            ,{'value':'11','label':'Grand Daughter'},{'value':'12','label':'Others'},{'value':'14','label':'Son-in-law'}
            ,{'value':'15','label':'Daugther-in-law'},{'value':'16','label':'Grand Mother'},{'value':'17','label':'Grand Father'}
            ,{'value':'18','label':'Sister in law'},{'value':'19','label':'Brother in law'}],

            relationValue:"",
            relationId:"",

            capturePhotoModal:false,
            camaraRadioButtonNew:true,
            uploadImageRadioButtonNew:false,
            selectedTypePhotoNew:"camara",
            showActivityImgCaptureNew:true,
            manualUploadImageNew:"",
            photoCaptureForActivityArrNew:[],
            validateActivityImageUpload:"",
            validatePhotoCapture:"",

            newNomineeName:"",
            newNomineeAge:"",

            newNomineeGenderArr:[{'value':'M','label':'Male'},{'value':"F",'label':'Female'}],
            newNomineeGenderValue:"",
            newNomineeGender:"",
            newNomineeRelationListArray:[{'value':'1','label':'Father'},{'value':'2','label':'Mother'},{'value':'3','label':'Wife'}
                ,{'value':'4','label':'Brother'},{'value':'5','label':'Sister'},{'value':'7','label':'Husband'}
                ,{'value':'8','label':'Son'},{'value':'9','label':'Daughter'},{'value':'10','label':'Grand Son'}
                ,{'value':'11','label':'Grand Daughter'},{'value':'12','label':'Others'},{'value':'14','label':'Son-in-law'}
                ,{'value':'15','label':'Daugther-in-law'},{'value':'16','label':'Grand Mother'},{'value':'17','label':'Grand Father'}
                ,{'value':'18','label':'Sister in law'},{'value':'19','label':'Brother in law'}],
    
            newNomineeRelationValue:"",
            newNomineeRelationId:"",


            saveEnrollLoadingSymbol:"",
            successMessageEnroll:"",
            enrollSubmitButtonDisabled:false,
            cardDetailsDisplay:"",

            useSameNomineeName:"",
			useSameNomineeGenderValue:"",
			useSameNomineeGender:"",
			useSameNomineeGenderArr:[{'value':'M','label':'Male'},{'value':"F",'label':'Female'}],
			useSameNomineeAge:"",
			useSameNomineeRelationValue:"",
			useSameNomineeRelation:"",
			useSameNomineeRelationArr:[{'value':'1','label':'Father'},{'value':'2','label':'Mother'},{'value':'3','label':'Wife'}
                ,{'value':'4','label':'Brother'},{'value':'5','label':'Sister'},{'value':'7','label':'Husband'}
                ,{'value':'8','label':'Son'},{'value':'9','label':'Daughter'},{'value':'10','label':'Grand Son'}
                ,{'value':'11','label':'Grand Daughter'},{'value':'12','label':'Others'},{'value':'14','label':'Son-in-law'}
                ,{'value':'15','label':'Daugther-in-law'},{'value':'16','label':'Grand Mother'},{'value':'17','label':'Grand Father'}
                ,{'value':'18','label':'Sister in law'},{'value':'19','label':'Brother in law'}],

            languageSelectionModal:false,
            englishSelected:props?.location?.params?.englishSelected == undefined ? true : this.props?.location?.params?.englishSelected,
            teleguSelected:props?.location?.params?.teleguSelected == undefined ? false : this.props?.location?.params?.teleguSelected,
            registrationType:props?.location?.params?.registrationType == undefined ? false : this.props?.location?.params?.registrationType,
            volunteerMobileNoInput:"",
            volunteerCouponsCount:"",
            isVolunteer:"",

            paymentWithDonationBlock:false,
            haveDonatePartyIdCheck:false,
            noDonatePartyIdCheck:false,
            otherDonationAmount:false,


            donationFirstPage:true,
            donationSecondPage:false,
            haveMemberShipIdCheck:false,
            noMemberShipIdCheck:false,

            donationName:"",
            donationGenderValue:"",
            donationGender:"",
            donationGenderArr:[{'value':'M','label':'Male'},{'value':"F",'label':'Female'}],
            donationAge:"",
            paynowDonationButtonDisabled:false,
            paynowDonationSuccessMessage:"",
            donationAmountValue:"",
            donationPanNumber:"",
            validatePanCardNumber:"",

            referenceMobileNoValue:"",
            regTypeInput:"",
            enabledPayNowButtonForOnlinePayment:false,
            validatePaymentMode:"",
            validateDonationAmount:"",

            enrollSubmitPayButtonDisabled:false,
            saveEnrollPayLoadingSymbol:"hide",
            successMessagePayEnroll:"",

            tdpCadreId:"",

            paymentGateWayInputDtsObj:{ "mobileNo" : "","personName" : "","tdpCadreId" : ""},
            validatefamilyVoterIdAge:"",
            validatefamilyVoterIdName:"",
            validatenewNomineeAge:"",
            validatenewNomineeName:"",
            volunteerConstituencyInput:"",
            volunterConstituencyName:"",
            validatePaymentOptionCheck:"",
            redirectToPaymentMsg:"",
            photoSelectedType:"",

            typeOfCardSelectedvalue:"",
            validateSearchMemberShip:"",
            rederalMembershipId:"",
            isSkipOTP:"N"

            
        }
        this.uploadMultipleFilesForPhotosNew = this.uploadMultipleFilesForPhotosNew.bind(this)
    }

    componentDidMount() {

        if(this.state.isVolunteerReloadCheck == ""){
            this.props.history.push({
                pathname: "/cadre_registration",
                params: {
                    navbarDisplay:"hide"
                },
            });
        }
        
        console.log("userAccessList",this.state)
			
        //this.checkUrlBrowser1();
        this.getMobileNoByChatId();

        this.setState({languageSelectionModal:true});


       /* var consArr=[];
        for(var i in  this.state.userAccessList.constituencyList){
            var obj={'value':this.state.userAccessList.constituencyList[i].id,'label':this.state.userAccessList.constituencyList[i].name};
            consArr.push(obj);
            
            
        }
       
        this.setState({ ap_listArr:consArr });
        this.setState({
            constituencyValue: {
            value: this.state.userAccessList.constituencyList[0].id,
            label: this.state.userAccessList.constituencyList[0].name
        },constituencyName:this.state.userAccessList.constituencyList[0].id
    });*/

    //this.getMandalsAndTownsByConstituencyId(this.state.userAccessList.constituencyList[0].id)
    }


    getMobileNoByChatId = () => {
        
        const obj =  
        JSON.stringify({ 
           "chatId" :this.state.chatID,
        }); 
    
        getAPICallDataForOnlyBSA(obj,"getMobileNoByChatId")
        .then((res) => res.json())
        .then((data) => {
            if(data !=null && data.mobileNo !=null){
                this.setState({referenceMobileNoValue:data.mobileNo});
                this.getVolunteerDetailsByMobileNo(data.mobileNo);
               }else if(data !=null && data.status == "Fail"){
                this.setState({referenceMobileNoValue:""})
               }else{
                this.setState({referenceMobileNoValue:""})
               }
        });
    }

    
    getVolunteerDetailsByMobileNo = (mobileNo) => {
    const obj =  
        JSON.stringify({ 
            "volunteerMobileNo" : mobileNo
        });

        getAPICallDataForCadreSaving(obj,"getVolunteerDetailsByMobileNo")
        .then((res) => res.json())
        .then((content) => {
            this.setState({referenceMobileNoValue:mobileNo});

            if(content !=null ){
                if(content.skipOtp == undefined){
                    this.setState({isSkipOTP:"N"})
                }else{
                    this.setState({isSkipOTP:content.skipOtp})
                }
                this.setState({isVolunteer:content.isVolunteer,volunteerConstituencyInput:content.constituencyId,volunterConstituencyName:content.constituencyName});
                if(content.isVolunteer == "Y"){
                    this.setState({volunteerCouponsCount:content.couponsCount,volunteerMobileNoInput:content.mobileNo});
                }else if(content.couponsCount == 0){
                    
                    this.setState({volunteerCouponsCount:0});
                }else{
                    this.setState({volunteerCouponsCount:"",volunteerMobileNoInput:""});
                }
               }else{
                    this.setState({isVolunteer:"",volunteerCouponsCount:"",volunteerMobileNoInput:"",volunteerConstituencyInput:"",volunterConstituencyName:"",isSkipOTP:"N"});
               }
        });
}

emptyFieldsSection = () => {
    this.setState({

        renewalDetailsLoading:"hide",
        renewalDetailsArr:[],
        renewalDetailsDataCheck:0,

        newEnrollFirstPage:true,
        newEnrollSecondPage:false,


        searchRenewalMembershipId:"",
        searchRenewalMobileNo:"",
        searchRenewalVoterId:"",
        userDetailsError:"",
        
        haveVoterIdCheck:false,
        noVoterIdCheck:false,

        constituencyValue:"",
        constituencyName:"",

        mandalLoadingSymbol:"hide",
        mandalValue:"",
        mandalName:"",

        genderValue:"",
        genderName:"",

        voterSearchName:"",
        
        familyVoterIdSearch:"",
        validateFamilyVoterIdSearch:"",
        familyVoterSearchLoading:"hide",
        familyVoterSearchObj:"",
        familyVoterSearchDataCheck:0,

        familyVoterIdName:"",
        familyVoterIdAge:"",
        familyVoterIdGenderValue:"",
        familyVoterIdGender:"",
        validatePersonDetails:"",

        
        newRegistrationInputObj:{},
        voterIdForNewEnroll:"",
        voterIdSearchVoterCardNo:"",
        voterIdSearchLoadingSymbol:"hide",
        voterIdSearchDetailsObj:{},
        voterIdSearchDataCheck:0,
        validateVoterIdSearch:"",


        familyDetailsLoading:"hide",
        familyDetailsArr:[],
        familyDetailsDataCheck:0,
        familyDetailsOpenBlock:true,

       


        captureMobileNo:"",
        validateCaptureMobileNo:"",
        captureOTPNO:"",
        validateCaptureOTP:"",

        mobileNoDisabled:false,
        otpBlockShow:false,

        smsSentMessage:"",
        otpVerifiedMessageStatus:"",
        otpLoadingSymbol:"hide",
        getOTPLoadingSymbol:"hide",
        OTPSentStatus:"",
        resendOTPLoadingSymbol:"hide",
        resendSmsSentMessage:"",

        
        
        minutes:1,
        seconds:0,
        OTPVerifiedDisabledButton:true,

       

    
        relationValue:"",
        relationId:"",

        capturePhotoModal:false,
        camaraRadioButtonNew:true,
        uploadImageRadioButtonNew:false,
        selectedTypePhotoNew:"camara",
        showActivityImgCaptureNew:true,
        manualUploadImageNew:"",
        photoCaptureForActivityArrNew:[],
        validateActivityImageUpload:"",
        validatePhotoCapture:"",

        newNomineeName:"",
        newNomineeAge:"",

        newNomineeGenderValue:"",
        newNomineeGender:"",

        newNomineeRelationValue:"",
        newNomineeRelationId:"",

        saveEnrollLoadingSymbol:"",
        successMessageEnroll:"",
        enrollSubmitButtonDisabled:false,
        cardDetailsDisplay:"",

        useSameNomineeName:"",
        useSameNomineeGenderValue:"",
        useSameNomineeGender:"",
        useSameNomineeGenderArr:[{'value':'','label':'Select Gender'},{'value':'M','label':'Male'},{'value':"F",'label':'Female'}],
        useSameNomineeAge:"",
        useSameNomineeRelationValue:"",
        useSameNomineeRelation:"",

        paymentWithDonationBlock:false,
        haveDonatePartyIdCheck:false,
        noDonatePartyIdCheck:false,
        otherDonationAmount:false,


        donationFirstPage:true,
        donationSecondPage:false,
        haveMemberShipIdCheck:false,
        noMemberShipIdCheck:false,

        donationName:"",
        donationGenderValue:"",
        donationGender:"",
        donationGenderArr:[{'value':'M','label':'Male'},{'value':"F",'label':'Female'}],
        donationAge:"",
        paynowDonationButtonDisabled:false,
        paynowDonationSuccessMessage:"",
        donationAmountValue:"",
        donationPanNumber:"",
        validatePanCardNumber:"",

        //referenceMobileNoValue:"",
        regTypeInput:"",
        enabledPayNowButtonForOnlinePayment:false,
        validatePaymentMode:"",
        validateDonationAmount:"",

        enrollSubmitPayButtonDisabled:false,
        saveEnrollPayLoadingSymbol:"hide",
        successMessagePayEnroll:"",

        tdpCadreId:"",
        validatefamilyVoterIdAge:"",
        validatefamilyVoterIdName:"",
        validatenewNomineeAge:"",
        validatenewNomineeName:"",
        validatePaymentOptionCheck:"",
        redirectToPaymentMsg:"",
        photoSelectedType:"",

        typeOfCardSelectedvalue:"",
        validateSearchMemberShip:"",
        paymentGateWayInputDtsObj:{ "mobileNo" : "","personName" : "","tdpCadreId" : ""},
        rederalMembershipId:""
        
        
    });
}

cardSelectedType = (e,type) => {
    this.setState({
            haveDonatePartyIdCheck:false,
            noDonatePartyIdCheck:false,
            otherDonationAmount:false,
            donationAmountValue:"",
            donationPanNumber:"",
            validatePanCardNumber:"",
            redirectToPaymentMsg:"",
            typeOfCardSelectedvalue:type,
            regTypeInput:""
    })

    
}


    enrollTypeRegister = (e,type) => {

        this.emptyFieldsSection();

        if(type == "newEnroll"){
            this.setState({ familyNomineeSelectedBlock:true,addNewNomineeSelectedBlock:false,useAsSameNomineeBlock:false})
        }else{
            this.setState({ familyNomineeSelectedBlock:false,addNewNomineeSelectedBlock:false,useAsSameNomineeBlock:true})
        }

        this.setState({enrollType:type})
    }


    haveVoterIdClick = (checkedType) => {
        this.setState({
            
            
            familyVoterIdSearch:"",
            validateFamilyVoterIdSearch:"",
            familyVoterSearchLoading:"hide",
            familyVoterSearchObj:"",
            familyVoterSearchDataCheck:0,

            
            newRegistrationInputObj:{},
            voterIdForNewEnroll:"",
            voterIdSearchVoterCardNo:"",
            voterIdSearchLoadingSymbol:"hide",
            voterIdSearchDetailsObj:{},
            voterIdSearchDataCheck:0,
            validateVoterIdSearch:"",
            redirectToPaymentMsg:""


            
        })

        if(checkedType == "yes"){
            this.setState({haveVoterIdCheck:true,noVoterIdCheck:false})
        }else{
            this.setState({haveVoterIdCheck:false,noVoterIdCheck:true})
        }
    }

    handleOnchangeAllowNumbersInputBox = (e) => {
        this.setState({validateSearchMemberShip:"",validateDonationAmount:"",validatefamilyVoterIdName:"",validatefamilyVoterIdAge:"",validatenewNomineeAge:"",validateCaptureMobileNo:"",validatenewNomineeName:""});
        const name = e.target.name;
        const value = e.target.value;
        const re = /^[0-9\b]+$/;
        const nameAndSpace = /^[A-Za-z\s]+$/;
    
        if(name == "familyVoterIdAge"){
            if (!re.test(e.target.value)) {
                this.setState({validatefamilyVoterIdAge:"Please Enter Numbers Only...  ",familyVoterIdAge:"" });
                return;
            }else{
                this.setState({validatefamilyVoterIdAge:"" });
            }
        }else if(name == "newNomineeAge"){
            if (!re.test(e.target.value)) {
                this.setState({validatenewNomineeAge:"Please Enter Numbers Only...  ",newNomineeAge:"" });
                return;
            }else{
                this.setState({validatenewNomineeAge:"" });
            }
        }else if(name == "captureMobileNo"){
            if (!re.test(e.target.value)) {
                this.setState({validateCaptureMobileNo:"Please Enter Numbers Only...  ",captureMobileNo:"" });
                return;
            }else{
                this.setState({validateCaptureMobileNo:"" });
            }
        }else if(name == "newNomineeName"){
            if (!nameAndSpace.test(e.target.value)) {
                this.setState({validatenewNomineeName:"Please Enter Alphabetic only",newNomineeName:""});
                return;
            }else{
                this.setState({validatenewNomineeName:"" });
            }
        }else if(name == "familyVoterIdName"){
            if (!nameAndSpace.test(e.target.value)) {
                this.setState({validatefamilyVoterIdName:"Please Enter Alphabetic only",familyVoterIdName:""});
                e.preventDefault();
                return;
            }else{
                this.setState({validatefamilyVoterIdName:"" });
            }
        }else if(name == "donationAmountValue"){
            if (!re.test(e.target.value)) {
                this.setState({validateDonationAmount:"Please Enter Numbers Only...  ",donationAmountValue:"" });
                return;
            }else{
                this.setState({validateDonationAmount:"" });
            }

            if (e.target.value == 0) {
                this.setState({validateDonationAmount:"Zero Number Not Allowed...  ",donationAmountValue:"" });
                return;
            }else{
                this.setState({validateDonationAmount:"" });
            }
        }/*else if(name == "searchRenewalMembershipId"){
            if (!re.test(e.target.value)) {
                this.setState({validateSearchMemberShip:"Enter Valid Membership Only...  ",searchRenewalMembershipId:"" });
                return;
            }else{
                this.setState({validateSearchMemberShip:"" });
            }
        }*/
        
    }

    handleOnchangeInputBox = (e) => {
        console.log("handleInputChange", e.target.name, e.target.value)
        const name = e.target.name;
        const value = e.target.value;

        this.setState({
            searchRenewalMembershipId: name === "membershipId" ? value : "",
            searchRenewalMobileNo: name === "mobileNo" ? value : "",
            searchRenewalVoterId: name === "voterId" ? value : "",
            userDetailsError: "",
            submitUserIds:false

        });

        if(name == "captureOTPNO"){
            this.setState({otpVerifiedMessageStatus:"",otpLoadingSymbol:"show"});
            if(value.length >= 6){
                this.validateMobileOtp(value);
               
            }
            
        }

        if(name == "donationPanNumber"){
            this.setState({[name]: value.toUpperCase()});
        }else{
            this.setState({ [name]: value });
        }
        
        
      }
    
handleOnchangeSelectBoxNew = (ename, evalue) =>{
    const name = ename;
    const value = evalue;

    if(name == "constituencyName"){
        this.setState({mandalValue:"",mandalName:""});

        let getConsIdName = this.state.ap_listArr.find((a) => a.value == value);
            this.setState({
                constituencyValue: {
                value: getConsIdName.value,
                label: getConsIdName.label
            }
        });

        this.getMandalsAndTownsByConstituencyId(value)
        
       
    }else if(name == "mandalName"){

        let getManIdName = this.state.mc_listArr.find((a) => a.value == value);
        console.log("getManIdName",getManIdName)
            this.setState({
                mandalValue: {
                value: getManIdName.value,
                label: getManIdName.label,
                typeId:getManIdName.typeId
            }
        });
    }else if(name == "genderName"){
        let getGenderIdName = this.state.genderListArr.find((a) => a.value == value);
            this.setState({
                genderValue: {
                value: getGenderIdName.value,
                label: getGenderIdName.label,
            }
        });
    }else if(name == "occupationStr"){
        let getOccIdName = this.state.occupationListArr.find((a) => a.value == value);
            this.setState({
                occupationStrValue: {
                value: getOccIdName.value,
                label: getOccIdName.label,
            }
        });
    }else if(name == "educationStr"){
        let getEduIdName = this.state.educationListArr.find((a) => a.value == value);
        this.setState({
            educationStrValue: {
            value: getEduIdName.value,
            label: getEduIdName.label,
        }
    });
    }else if(name == "casteIdStr"){
        let getCasteIdName = this.state.caste_ids_Arr.find((a) => a.value == value);
        this.setState({
            casteIdStrValue: {
            value: getCasteIdName.value,
            label: getCasteIdName.label,
        }
    });
    }else if(name == "relationId"){
        let getRelIdName = this.state.relationListArray.find((a) => a.value == value);
        this.setState({
            relationValue: {
            value: getRelIdName.value,
            label: getRelIdName.label,
        }
    });
    }else if(name == "newNomineeGender"){
        let getGenderIdName = this.state.newNomineeGenderArr.find((a) => a.value == value);
            this.setState({
                newNomineeGenderValue: {
                value: getGenderIdName.value,
                label: getGenderIdName.label,
            }
        });
    }else if(name == "familyVoterIdGender"){
        let getGenderIdName = this.state.familyVoterIdGenderArr.find((a) => a.value == value);
            this.setState({
                familyVoterIdGenderValue: {
                value: getGenderIdName.value,
                label: getGenderIdName.label,
            }
        });
    }else if(name == "newNomineeRelationId"){
        let getRelIdName = this.state.newNomineeRelationListArray.find((a) => a.value == value);
        this.setState({
            newNomineeRelationValue: {
            value: getRelIdName.value,
            label: getRelIdName.label,
        }
    });
    }else if(name == "useSameNomineeGender"){
        let getIdName = this.state.useSameNomineeGenderArr.find((a) => a.value == value);
        this.setState({
            useSameNomineeGenderValue: {
            value: getIdName.value,
            label: getIdName.label,
        }
    });
    }else if(name == "useSameNomineeRelation"){
        let getIdName = this.state.useSameNomineeRelationArr.find((a) => a.value == value);
        this.setState({
            useSameNomineeRelationValue: {
            value: getIdName.value,
            label: getIdName.label,
        }
    });
    }else if(name == "donationGender"){
        let getGenderIdName = this.state.donationGenderArr.find((a) => a.value == value);
            this.setState({
                donationGenderValue: {
                value: getGenderIdName.value,
                label: getGenderIdName.label,
            }
        });
    }
      

    this.setState({ [name]: value});
  }
      
  getMandalsAndTownsByConstituencyId = (locationId) => {
    this.setState({mandalLoadingSymbol:"show"});
    const obj =  
    JSON.stringify({ 
        "locationId" : locationId,
    }); 

    getAPICallDataForOnlyBSA(obj,"getMandalsAndTownsByConstituencyId")
    .then((res) => res.json())
    .then((data) => {
        this.setState({mandalLoadingSymbol:"hide"});
      if(data !=null && data.length > 0){
        let parlArr=[];
        data.map(item => {
            const obj = {
                value: item.id,
                label: item.name,
                typeId:item.typeId
            }
            parlArr.push(obj);
            
        });
        this.setState({ mc_listArr: parlArr });

      }else{
        this.setState({ mc_listArr:[]});
      }
    });
}

submitUserIds = (e) => {

    const { searchRenewalMobileNo, searchRenewalVoterId, searchRenewalMembershipId } = this.state;

    if (!searchRenewalMobileNo && !searchRenewalVoterId && !searchRenewalMembershipId) {
        this.setState({
            userDetailsError: "Enter any of the inputs"
        });
        return;
    } else {
        this.setState({
            userDetailsError: "",
            submitUserIds:true
        });

        if(searchRenewalMembershipId !="" && searchRenewalMobileNo == "" && searchRenewalVoterId == ""){
            if(this.state.searchRenewalMembershipId.length < 8){
                this.setState({
                    userDetailsError: "Please Enter 8 Digits Valid Membership Id"
                });
                return;
            }
        }else if(searchRenewalMembershipId =="" && searchRenewalMobileNo != "" && searchRenewalVoterId == ""){
            var expr = /^(0|91)?[6-9][0-9]{9}$/;

            if(this.state.searchRenewalMobileNo == ""){
                this.setState({userDetailsError:"Please Enter Mobile No" });
                return;
            }

            if(!expr.test(this.state.searchRenewalMobileNo)){
                this.setState({userDetailsError:"Please Enter Valid Mobile No" });
                return;
            }

            if(this.state.searchRenewalMobileNo.length < 10){
                this.setState({userDetailsError:"Please Enter Valid Mobile No" });
                return;
            }
        }

        console.log("dddsdsafsafs",searchRenewalMobileNo,searchRenewalVoterId,searchRenewalMembershipId)

        this.getCitVlorSearchDetails(searchRenewalMobileNo,searchRenewalVoterId,searchRenewalMembershipId);

    }
}

getCitVlorSearchDetails = (mobileNo,vno,mid) => {
    
    this.setState({renewalDetailsLoading:"show",renewalDetailsArr:[],renewalDetailsDataCheck:0});

    const obj =  
        JSON.stringify({ 
            "mid" : mid,
            "mobileNo" : mobileNo,
            "vno" : vno,
            "constituencyId" : this.state.volunteerConstituencyInput,
            "username" : "app_api_cadre",
            "password" : "6Da3!p#w$5xqinRk"
        });

        getAPICallDataForCadre(obj,"getCitVlorSearchDetails")
        .then((res) => res.json())
        .then((content) => {
            this.setState({renewalDetailsLoading:"hide"})
            if(content !=null && content.length>0){
                this.setState({renewalDetailsArr:content,renewalDetailsDataCheck:0});
            }else{
                this.setState({renewalDetailsArr:"",renewalDetailsDataCheck:1});
            }
        });
    
    
}

getFamilyVoterDetailsByVoterCardNo = () => {
    this.setState({validateFamilyVoterIdSearch:""})
    if(!this.state.familyVoterIdSearch){
        this.setState({validateFamilyVoterIdSearch:"Please Enter Voter Card No..." });
        return;
    }

    this.setState({familyVoterSearchLoading:"show",familyVoterSearchObj:"",familyVoterSearchDataCheck:0});

    const obj =  
        JSON.stringify({ 
            "vno" : this.state.familyVoterIdSearch,
            "constituencyId":this.state.volunteerConstituencyInput,
            "username" : "app_api_cadre",
            "password" : "6Da3!p#w$5xqinRk"
        });

        getAPICallDataForCadre(obj,"getPersonDetailsByVno")
        .then((res) => res.json())
        .then((content) => {
            this.setState({familyVoterSearchLoading:"hide"})
            if(content !=null){
                this.setState({familyVoterSearchObj:content,familyVoterSearchDataCheck:0});
            }else{
                this.setState({familyVoterSearchObj:"",familyVoterSearchDataCheck:1});
            }
        });
    
    
}

getVoterDetailsByVoterCardNo = () => {
    scroller.scrollTo("moveToPoint", { 
        duration: 800,
        delay: 0,
        smooth: "easeInOutQuart",
    });
    this.setState({validateVoterIdSearch:""})
    if(!this.state.voterIdSearchVoterCardNo){
        this.setState({validateVoterIdSearch:"Please Enter Voter Card No..." });
        return;
    }

    this.setState({voterIdSearchLoadingSymbol:"show",voterIdSearchDetailsObj:{},voterIdSearchDataCheck:0});

    const obj =  
        JSON.stringify({ 
            "vno" : this.state.voterIdSearchVoterCardNo,
            "constituencyId":this.state.volunteerConstituencyInput,
            "username" : "app_api_cadre",
            "password" : "6Da3!p#w$5xqinRk"
        });

        getAPICallDataForCadre(obj,"getPersonDetailsByVno")
        .then((res) => res.json())
        .then((content) => {
            this.setState({voterIdSearchLoadingSymbol:"hide"})
            if(Object.keys(content).length > 0){
                this.setState({voterIdSearchDetailsObj:content,voterIdSearchDataCheck:0});
            }else{
                this.setState({voterIdSearchDetailsObj:{},voterIdSearchDataCheck:1});
            }
           
        });
    
    
}

getMobileNoOTP = () => {
    this.setState({validateCaptureMobileNo:"" });
    var expr = /^(0|91)?[6-9][0-9]{9}$/;

    if(this.state.captureMobileNo == ""){
        this.setState({validateCaptureMobileNo:"Please Enter Mobile No" });
        return;
    }

    if(!expr.test(this.state.captureMobileNo)){
        this.setState({validateCaptureMobileNo:"Please Enter Valid Mobile No" });
        return;
    }

    if(this.state.captureMobileNo.length < 10){
        this.setState({validateCaptureMobileNo:"Please Enter Valid Mobile No" });
        return;
    }


    this.setState({smsSentMessage:"",getOTPLoadingSymbol:"show",OTPSentStatus:"",otpVerifiedValue:0});
    
    const obj =  
        JSON.stringify({ 
        "chatId" :this.state.chatID,
        "mobileNo" : this.state.captureMobileNo,
        "volunteerMobileNo" : this.state.volunteerMobileNoInput,
        
        }); 

        getAPICallDataForOnlyBSA(obj,"sendOTPForCitVlorRegistration")
        .then((res) => res.json())
        .then((data) => {
        this.setState({getOTPLoadingSymbol:"hide"});
        if(data !=null && data.status == "Success"){
           // console.log(jwt_decode(data.reference).sub)
            this.setState({smsSentMessage:"OTP Sent Your Mobile No",OTPSentStatus:data.status,otpVerifiedValue:1});
            this.setState({OTPVerifiedDisabledButton:false,mobileNoDisabled:true})
            this.OTPTimerFunction();
        }else if(data !=null && data.status == "Fail"){
            this.setState({smsSentMessage:data.message,OTPSentStatus:"Fail",otpVerifiedValue:0});
            this.setState({OTPVerifiedDisabledButton:true})
        }else{
            this.setState({smsSentMessage:"Some Thing Went Wrong,Please Try Again...",OTPSentStatus:"Fail",otpVerifiedValue:0});
            this.setState({OTPVerifiedDisabledButton:true})
        }
        });
}

resendOTPTimer = () => {
    this.setState({minutes:1});
    this.setState({seconds:0});

    this.OTPTimerFunction();
};

OTPTimerFunction = () => {
    const interval = setInterval(() => {
        if (this.state.seconds > 0) {
        this.setState({seconds:this.state.seconds - 1});
        }

        if (this.state.seconds === 0) {
        if (this.state.minutes === 0) {
            clearInterval(interval);
        } else {
            this.setState({seconds:90});
            this.setState({minutes:this.state.minutes - 1});

        }
        }
    }, 1000);

    return () => {
        clearInterval(interval);
    };
}

resendOTPNew = () => {
    this.setState({validateCaptureMobileNo:"",OTPVerifiedDisabledButton:false });
    if(this.state.captureMobileNo == ""){
        this.setState({validateCaptureMobileNo:"Please Enter Mobile No" });
        return;
    }
    var expr = /^(0|91)?[6-9][0-9]{9}$/;
    if(!expr.test(this.state.captureMobileNo)){
        this.setState({validateCaptureMobileNo:"Please Enter Valid Mobile No" });
        return;
    }

    

    if(this.state.captureMobileNo.length < 10){
        this.setState({validateCaptureMobileNo:"Please Enter Valid Mobile No" });
        return;
    }

    this.setState({resendOTPLoadingSymbol:"show",otpVerifiedValue:0});

    const obj =  
        JSON.stringify({ 
           "chatId" :this.state.chatID,
            "mobileNo" : this.state.captureMobileNo,
            "volunteerMobileNo" : this.state.volunteerMobileNoInput,
        
        }); 

        getAPICallDataForOnlyBSA(obj,"sendOTPForCitVlorRegistration")
        .then((res) => res.json())
        .then((data) => {
        this.setState({resendOTPLoadingSymbol:"hide"});
        if(data !=null && data.status == "Success"){
            //console.log(jwt_decode(data.reference).sub)
            this.setState({otpVerifiedValue:1});
            this.resendOTPTimer();
        }else{
            this.setState({otpVerifiedValue:0});
        }
        });
    
}

validateMobileOtp = (otp) => {
this.setState({otpVerifiedMessageStatus:"",otpLoadingSymbol:"show",validateCaptureOTP:""});
const obj =  
    JSON.stringify({ 
    "chatId" :this.state.chatID,
    "mobileNo" : this.state.captureMobileNo,
    "otp" : otp,
    "volunteerMobileNo" : this.state.volunteerMobileNoInput,
    

    }); 

    getAPICallDataForOnlyBSA(obj,"verifyCitVlorRegistrationOTP")
    .then((res) => res.json())
    .then((data) => {
    this.setState({otpLoadingSymbol:"hide"});
    if(data !=null && data.status == "Success"){
        this.setState({otpVerifiedMessageStatus:"Verified",OTPVerifiedDisabledButton:true,mobileNoDisabled:true,validateCaptureOTP:""});
    }else{
        this.setState({otpVerifiedMessageStatus:"NotVerified",OTPVerifiedDisabledButton:false});
    }
    });
}

secondPageNewMemberShip = (data,voterIdType) => {
    this.setState({

        familyDetailsLoading:"hide",
        familyDetailsArr:[],
        familyDetailsDataCheck:0,
        familyDetailsOpenBlock:true,

       


        captureMobileNo:"",
        validateCaptureMobileNo:"",
        captureOTPNO:"",
        validateCaptureOTP:"",

        otpBlockShow:false,
        mobileNoDisabled:false,

        smsSentMessage:"",
        otpVerifiedMessageStatus:"",
        otpLoadingSymbol:"hide",
        getOTPLoadingSymbol:"hide",
        OTPSentStatus:"",
        resendOTPLoadingSymbol:"hide",
        resendSmsSentMessage:"",

        
        
        minutes:1,
        seconds:0,
        OTPVerifiedDisabledButton:true,

       

    
        relationValue:"",
        relationId:"",

        capturePhotoModal:false,
        camaraRadioButtonNew:true,
        uploadImageRadioButtonNew:false,
        selectedTypePhotoNew:"camara",
        showActivityImgCaptureNew:true,
        manualUploadImageNew:"",
        photoCaptureForActivityArrNew:[],
        validateActivityImageUpload:"",
        validatePhotoCapture:"",

        newNomineeName:"",
        newNomineeAge:"",

        newNomineeGenderValue:"",
        newNomineeGender:"",

        newNomineeRelationValue:"",
        newNomineeRelationId:"",

        saveEnrollLoadingSymbol:"",
        successMessageEnroll:"",
        enrollSubmitButtonDisabled:false,
        cardDetailsDisplay:"",

        haveDonatePartyIdCheck:false,
        noDonatePartyIdCheck:false,
        redirectToPaymentMsg:"",
        photoSelectedType:"",
        typeOfCardSelectedvalue:""
        
    });

    this.setState({voterIdForNewEnroll:data.vid});

    

    


    var obj={};

    if(voterIdType == "yes"){
        obj={
            "tcid":null,
            "vid":data.vid,
            "fvid":0,
            "cname":data.personName,
            "gender":data.gender,
            "age":data.age,
            "mobileNumber":"",
            "fmName":"",
            "fmGender":"",
            "fmAge":0,
            "fmRelationId":0,
            "volunteerMobileNo" : "",
            "imageBase64String" : "",
            "refMobileNo" : this.state.referenceMobileNoValue,
	        "regType" : "",
            //"membershipType" : this.state.registrationType == "lifeTime" ?  "Permanent" : "General",
            "membershipType":"",
            "imageStatus":"",
            "imageUrl":"",
            "appId" : "TBot-1",
            "referralId" : "",
        }

        this.setState(Object.assign(this.state.paymentGateWayInputDtsObj,{mobileNo:this.state.captureMobileNo,personName:data.personName,tdpCadreId:""}));
    

    }else{
        obj={
            "tcid":null,
            "vid":0,
            "fvid":data.vid,
            "cname":data.personName,
            "gender":data.gender,
            "age":data.age,
            "mobileNumber":"",
            "fmName":"",
            "fmGender":"",
            "fmAge":0,
            "fmRelationId":0,
            "volunteerMobileNo" : "",
            "imageBase64String" : "",
            "refMobileNo" : this.state.referenceMobileNoValue,
	        "regType" : "",
            //"membershipType" : this.state.registrationType == "lifeTime" ?  "Permanent" : "General",
            "membershipType":"",
            "imageStatus":"",
            "imageUrl":"",
            "appId" : "TBot-1",
            "referralId" : "",
        }

        
    }
    

    this.setState({newRegistrationInputObj:obj,photoSelectedType:"newPhoto"});
    this.getCitVlorFMDetailsForNM(data.vid);

    setTimeout(() => {
        if(this.state.registrationType == "general"){
            this.setState({typeOfCardSelectedvalue:"generalCardSelected"})
        }else{
            this.setState({typeOfCardSelectedvalue:"lifeCardSelected"})
        }
    }, 500);
    
    

    this.setState({newEnrollFirstPage:false,newEnrollSecondPage:true});
}

changeMobileNo = () => {
    this.setState({
        validateCaptureMobileNo:"",
        captureOTPNO:"",
        validateCaptureOTP:"",

        mobileNoDisabled:false,
        otpBlockShow:false,

        smsSentMessage:"",
        otpVerifiedMessageStatus:"",
        otpLoadingSymbol:"hide",
        getOTPLoadingSymbol:"hide",
        OTPSentStatus:"",
        resendOTPLoadingSymbol:"hide",
        resendSmsSentMessage:"",

       
        
        minutes:1,
        seconds:0,
        OTPVerifiedDisabledButton:true,
    });
}

secondPageRenewalFromNewMemberShip = (data) => {
    this.secondPageRenewalFromNewSearchDts(data.mid);
}

secondPageRenewalFromNewSearchDts = (mid) => {
    const obj =  
        JSON.stringify({ 
            "mid" : mid,
            "mobileNo" : "",
            "vno" : "",
            "constituencyId" : this.state.volunteerConstituencyInput,
            "username" : "app_api_cadre",
            "password" : "6Da3!p#w$5xqinRk"
        });

        getAPICallDataForCadre(obj,"getCitVlorSearchDetails")
        .then((res) => res.json())
        .then((content) => {
            if(content !=null && content.length>0){
                const obj = Object.assign({}, ...content);

                this.secondPageRenewalMemberShip(obj);
                this.setState({enrollType:"renewalfromNew",familyNomineeSelectedBlock:false,addNewNomineeSelectedBlock:false,useAsSameNomineeBlock:true})
            }
        });
}

secondPageRenewalMemberShip = (data) => {
    console.log("datadatadata",data)
    //this.setState({paymentGateWayInputDtsObj:{}});
    this.setState({
        

        capturePhotoModal:false,
        camaraRadioButtonNew:true,
        uploadImageRadioButtonNew:false,
        selectedTypePhotoNew:"camara",
        showActivityImgCaptureNew:true,
        manualUploadImageNew:"",
        photoCaptureForActivityArrNew:[],
        validateActivityImageUpload:"",
        validatePhotoCapture:"",

        captureMobileNo:"",
        validateCaptureMobileNo:"",
        captureOTPNO:"",
        validateCaptureOTP:"",

        otpBlockShow:false,
        

        smsSentMessage:"",
        otpVerifiedMessageStatus:"",
        otpLoadingSymbol:"hide",
        getOTPLoadingSymbol:"hide",
        OTPSentStatus:"",
        resendOTPLoadingSymbol:"hide",
        resendSmsSentMessage:"",

        
        
        minutes:1,
        seconds:0,
        OTPVerifiedDisabledButton:true,

        

        saveEnrollLoadingSymbol:"",
        successMessageEnroll:"",
        enrollSubmitButtonDisabled:false,
        cardDetailsDisplay:"",

        useSameNomineeName:"",
        useSameNomineeGenderValue:"",
        useSameNomineeGender:"",
        useSameNomineeGenderArr:[{'value':'','label':'Select Gender'},{'value':'M','label':'Male'},{'value':"F",'label':'Female'}],
        useSameNomineeAge:"",
        useSameNomineeRelationValue:"",
        useSameNomineeRelation:"",

        haveDonatePartyIdCheck:false,
        noDonatePartyIdCheck:false,
        redirectToPaymentMsg:"",
        typeOfCardSelectedvalue:""
        
    });

    console.log("this.state.referenceMobileNo",this.state.referenceMobileNoValue)

    var obj={
        "tcid":data.cid,
        "fvid":0,
        "cname":typeof data.cname == "undefined" ? data.personName	: data.cname,
        "gender":data.gender,
        "age":data.age,
        "mobileNumber":data.mobileNo,
        "fmName":data.fmName,
        "fmGender":data.fmGender,
        "fmAge":data.fmAge,
        "fmRelationId":data.fmRelationId,
        "volunteerMobileNo" : "",
        "imageBase64String" : "",
        "refMobileNo" : this.state.referenceMobileNoValue,
	    "regType" : "",
        //"membershipType" : this.state.registrationType == "lifeTime" ?  "Permanent" : "General",
        "membershipType":"",
        "imageStatus":data.imageStatus == "N" || data.imageStatus == "" ? "" : data.imageStatus,
        "imageUrl":data.imageUrl,
        "appId" : "TBot-1",
        "referralId" : "",
    }

    this.setState(Object.assign(this.state.paymentGateWayInputDtsObj,{mobileNo:data.mobileNo,personName:data.cname,tdpCadreId:data.cid}));

    if(data.imageStatus == "Y"){
        this.setState({photoSelectedType:"useExistingPhoto"})
    }else{
        this.setState({photoSelectedType:"newPhoto"})
    }

    setTimeout(() => {
        if(this.state.registrationType == "general"){
            this.setState({typeOfCardSelectedvalue:"generalCardSelected"})
        }else{
            this.setState({typeOfCardSelectedvalue:"lifeCardSelected"})
        }

    }, 500);

    this.setState({newEnrollFirstPage:false,newEnrollSecondPage:true});
    this.setState({newRegistrationInputObj:obj});

    

    if(typeof(data.mobileNo) == "undefined"){
        this.setState({captureMobileNo:"",mobileNoDisabled:false});
    }else if(data.mobileNo == ""){
        this.setState({captureMobileNo:"",mobileNoDisabled:false});
    }else{
        this.setState({captureMobileNo:data.mobileNo,mobileNoDisabled:true});
    }

    

    this.setState({
        useSameNomineeGenderValue: {
        value: data.fmGender != "" ? data.fmGender : "",
        label: data.fmGender == "M" ? "Male" : data.fmGender == "F" ? "Female" : "Select Gender"
    },useSameNomineeGender:data.fmGender != "" ? data.fmGender : ""
    });

    this.setState({useSameNomineeName:data.fmName,useSameNomineeAge:data.fmAge == "" || data.fmAge ==  0 ? "" : data.fmAge});

    this.setState({
        useSameNomineeRelationValue: {
        value: data.fmRelationId,
        label: data.fmRelation
    },useSameNomineeRelation:data.fmRelationId
    });

    console.log("ddddddddddddddss",this.state.paymentGateWayInputDtsObj)

    

    this.getCitVlorFMDetailsForNM(data.vid);
}

getCitVlorFMDetailsForNM = (voterId) => {
    this.setState({familyDetailsLoading:"show",familyDetailsArr:[],familyDetailsDataCheck:0});

    const obj =  
        JSON.stringify({ 
            "vid":voterId,
            "username" : "app_api_cadre",
            "password" : "6Da3!p#w$5xqinRk"
        });

        getAPICallDataForCadre(obj,"getCitVlorFMDetailsForNM")
        .then((res) => res.json())
        .then((content) => {
            this.setState({familyDetailsLoading:"hide"})
            if(content !=null && content.length>0){
                const familyData =  content.map((item) => {
                    return { ...item,checked:false }
                });
                this.setState({familyDetailsArr:familyData,familyDetailsDataCheck:0});
            }else{
                this.setState({familyDetailsArr:[],familyDetailsDataCheck:1});
            }
        });
}
familyDetailsOpenClick = () => {
    this.setState({familyDetailsOpenBlock:!this.state.familyDetailsOpenBlock });
}


familyDetailsDisplayColumns() {
    let columns = [
        
       
        {
            dataField: "Name",
            text: "Name",
            formatter: this.actionsFormatterForNameCC.bind(this),
            headerStyle: {
                width: "50%"
            }
        },
        {
            dataField: "Age",
            text: "Age",
            sort: true,
            headerStyle: {
                width: "10%"
            }
            
        },

        {
            dataField: "Gender",
            text: "Gender",
            sort: true,
            headerStyle: {
                width: "15%"
            }
        },
        {
            dataField: "Actions",
            text: "Check",
            formatter: this.actionsFormatterForSelectedFamily.bind(this),
            headerStyle: {
                width: "20%"
            }
            
        },

        
    
    ];
    return columns;
}

actionsFormatterForNameCC = (cell, row, rowIndex, formatExtraData) => {
    return (
        <span style={{textAlign:"left",marginLeft:"0px"}}>{row.Name} 
            <><br/><span className='f-10 color_red'>VCN: {row.voterCardNo}</span></>
        </span>
     );
}

actionsFormatterForSelectedFamily = (cell, row, rowIndex, formatExtraData) => {
    return (
        <>
            {
                <Form>
                    <div className='text-center'>
                        <Form.Check
                            inline
                            label={""}
                            name={`familyCheckVoterName`}
                            type="radio"
                            id={`familyCheckVoterId-${row.voterId}`}
                            className="f-16 input_style"
                            checked={row.checkedVal}
                            onChange={(e)=>this.getSelectedFamilyVoterForNominnee(e,row)}
                        />
                    </div>
                </Form>
            }
        </>
        
          
     );
}

familyDetailsDisplayData = () => {
    let votersData = [];
    if(this.state.familyDetailsArr.length>0){
        
        for (let i = 0; i < this.state.familyDetailsArr.length; i++) {

            const personName = (this.state.familyDetailsArr[i].personName);
            const cardNo = (this.state.familyDetailsArr[i].cardNo);
            const vid = (this.state.familyDetailsArr[i].vid);
            const age = (this.state.familyDetailsArr[i].age);
            const gender = (this.state.familyDetailsArr[i].gender);
            const checkedData = (this.state.familyDetailsArr[i].checked);
            
            const obj = {
                Name: personName,
                Age: age,
                Gender: gender,
                voterId:vid,
                voterCardNo:cardNo,
                checkedVal:checkedData
                
                
            }
            votersData.push(obj);
        } 

        
        
        return votersData;
    }
}

getSelectedFamilyVoterForNominnee = (e,data) => {
    const dataArr =  this.state.familyDetailsArr.map((item) => {
        if(item.vid == data.voterId){
            return { ...item, checked: true}
        }else{
            return { ...item, checked: false }
        }
       
    });
    this.setState({familyDetailsArr:dataArr});
    this.setState({familyDetailsOpenBlock:!this.state.familyDetailsOpenBlock });

    console.log("newRegistrationInputObj",this.state.familyDetailsArr)

    setTimeout(() => {
        if(this.state.familyDetailsArr.length>0){
            for(var i in this.state.familyDetailsArr){
                if(this.state.familyDetailsArr[i].checked == true){
                    
                    this.setState(prevState => ({
                        newRegistrationInputObj: {                   
                            ...prevState.newRegistrationInputObj,   
                            fmName: this.state.familyDetailsArr[i].personName,
                            fmGender:this.state.familyDetailsArr[i].gender,
                            fmAge:this.state.familyDetailsArr[i].age   
                        }
                    }))
                }
            }
        }
    }, 1000);
    
}


previousFirstPageNewMemberShip = () => {
    if(this.state.enrollType == "renewalfromNew"){
        this.setState({enrollType:"newEnroll"})
    }
    
    setTimeout(() => {
        this.setState({newEnrollFirstPage:true,newEnrollSecondPage:false});
    }, 500);
    
}

previousFirstPageNewMemberShipPAYButton = () => {
    this.setState({
        haveDonatePartyIdCheck:false,
        noDonatePartyIdCheck:false,
        otherDonationAmount:false,
        donationAmountValue:"",
        donationPanNumber:"",
        validatePanCardNumber:"",
        redirectToPaymentMsg:""
    })

    if(this.state.registrationType == "general"){
        this.setState({typeOfCardSelectedvalue:"generalCardSelected"})
    }else{
        this.setState({typeOfCardSelectedvalue:"lifeCardSelected"})
    }

    this.setState({newEnrollFirstPage:true,paymentWithDonationBlock:false});
}

typeOfNominneeSeleted = (e,type) => {
    this.setState({validateNomineeDetails:"",validateNomineeReletion:""});
    const dataArr =  this.state.familyDetailsArr.map((item) => {
        return { ...item, checked: false }
       
    });
    this.setState({familyDetailsArr:dataArr});

    this.setState(prevState => ({
        newRegistrationInputObj: {                   
            ...prevState.newRegistrationInputObj,   
            fmName: "",
            fmGender:"",
            fmAge:"",
            fmRelationId:0  
        }
    }));
    

    if(type == "family"){
        this.setState({familyNomineeSelectedBlock:true,addNewNomineeSelectedBlock:false,useAsSameNomineeBlock:false})
    }else if(type == "newNominee"){
        this.setState({familyNomineeSelectedBlock:false,addNewNomineeSelectedBlock:true,useAsSameNomineeBlock:false})
    }else if(type == "sameNominee"){
        this.setState({familyNomineeSelectedBlock:false,addNewNomineeSelectedBlock:false,useAsSameNomineeBlock:true})
    }
}

capturePhotoForCadreEnroll = () => {
    this.setState({capturePhotoModal:true,validatePhotoCapture:""})
}

uploadImageForMembership = () => {
    if(this.state.selectedTypePhotoNew == "camara"){
        if(this.state.photoCaptureForActivityArrNew.length == 0){
            this.setState({validateActivityImageUpload:"Please Take A Photo..."});
            return;
        }
    }else if(this.state.selectedTypePhotoNew == "upload"){
        if(this.state.photoCaptureForActivityArrNew.length == 0){
            this.setState({manualUploadImageNew:"Please Upload Photo..."});
            return;
        }
    }

    console.log("aaaaaaaa",this.state.photoCaptureForActivityArrNew)

    setTimeout(() => {
        if(this.state.photoCaptureForActivityArrNew.length > 0){
            for(var i in this.state.photoCaptureForActivityArrNew){
                if(this.state.selectedTypePhotoNew == "upload"){
                    this.setState(Object.assign(this.state.newRegistrationInputObj,{"imageBase64String": this.state.photoCaptureForActivityArrNew[i].data.replace("data:"+this.state.photoCaptureForActivityArrNew[i].fileType+";base64,","")}));
                }else{
                    this.setState(Object.assign(this.state.newRegistrationInputObj,{"imageBase64String": this.state.photoCaptureForActivityArrNew[i].data.replace("data:image/jpeg;base64,","")}));
                }
                
            }
        }

        console.log("aaaaaa",this.state.newRegistrationInputObj)
    }, 1000);

    

    this.setState({capturePhotoModal:false})
}
  
selectCaptureTypeNew = (type) => {
    this.setState({photoCaptureForActivityArrNew:[],manualUploadImageNew:"",validateActivityImageUpload:""});
   
        
    if(type == "upload"){
      this.setState({ camaraRadioButtonNew:false,uploadImageRadioButtonNew:true});
      this.setState({showActivityImgCaptureNew:false});
    }else{
      this.setState({ camaraRadioButtonNew:true,uploadImageRadioButtonNew:false});
      this.setState({showActivityImgCaptureNew:true});
    }
    

    this.setState({selectedTypePhotoNew:type});
  }

  toDataURL = url => fetch(url)
      .then(response => response.blob())
      .then(blob => new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onloadend = () => resolve(reader.result)
      reader.onerror = reject
      reader.readAsDataURL(blob)
    }))

    uploadMultipleFilesForPhotosNew = async(e) => {
        this.setState({photoCaptureForActivityArrNew:[]});
        this.setState({manualUploadImageNew:""});
        const getUID = (length=8) => {
            var result           = '';
            var characters       = '0123456789';
            var charactersLength = characters.length;
            for ( var i = 0; i < length; i++ ) {
              result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result;
          }
    
        let fileObj=[];
          fileObj.push(e.target.files);
              for (let i = 0; i < fileObj[0].length; i++) {
    
                if(fileObj[0][i].type == "image/jpeg" || fileObj[0][i].type == "image/png" || fileObj[0][i].type == "image/jpg"){
                        this.toDataURL(URL.createObjectURL(fileObj[0][i]))
                        .then(async (dataUrl)  => {
                            this.setState({manualUploadImageNew:"Photo is Validating...Please wait"});
    
                                await fetch( 'https://www.mypartydashboard.com/BSA/WebService/validateImage', {
                                    method: "POST", 
                                    headers: {
                                        'Accept': 'application/json',
                                        'Content-Type': 'application/json',
                                    },
                                    body: JSON.stringify({
                                        "base64Str": dataUrl.replace("data:"+fileObj[0][i].type+";base64,",""),
                                    
                                    }), 
                                })
                                .then((response) => {
                                    this.setState({manualUploadImageNew:""});
                                    // 1. check response.ok
                                    if (response.ok) {
                                    return response.json();
                                    }
                                    //return Promise.reject(response); // 2. reject instead of throw
                                })
                                .then(responseData => {console.log(responseData); return responseData;})
                                .then((final_result) => {
                                    console.log("image",Object.keys(final_result.result.bodylength).length)
                                    console.log("image",final_result.result.bodylength.lengthAccepted)
                    
                                    // all good, token is ready
                                    if(Object.keys(final_result.result.bodylength).length > 0){
                                        //const isNameAvailable = final_result.result.detect_objs.find(item => item.name == 'person');
                                        //console.log("isNameAvailable",isNameAvailable)
                                        console.log("image",final_result.result.bodylength.lengthAccepted)
                                        console.log("image",final_result.result.bodylength.reject_reason[0])
                    
                                        if(final_result.result.bodylength.lengthAccepted == true && final_result.result.bodylength.reject_reason.length == 0){
                                            var obj ={
                                                fileId:getUID(),
                                                fileType:fileObj[0][i].type,
                                                data:dataUrl,
                                            }
                                            this.setState({photoCaptureForActivityArrNew:[...this.state.photoCaptureForActivityArrNew, obj]});
                    
                                            this.setState({manualUploadImageNew:"Photo Upload Successfully..."});
                                        }else{
                                            this.setState({manualUploadImageNew:"Please Upload Valid Photo and Photo Should be in straight view"});
                                        }
                                    }else{
                                        this.setState({manualUploadImageNew:"Please Upload Valid Photo and Photo Should be in straight view"});
                                    }
                                })
                                .catch((response) => {
                                    var obj ={
                                        fileId:getUID(),
                                        fileType:fileObj[0][i].type,
                                        data:dataUrl,
                                    }
                                    this.setState({photoCaptureForActivityArrNew:[...this.state.photoCaptureForActivityArrNew, obj]});
                                    this.setState({manualUploadImageNew:"Photo Upload Successfully..."});
                                    response.json().then((json) => {
                                        var obj ={
                                            fileId:getUID(),
                                            fileType:fileObj[0][i].type,
                                            data:dataUrl,
                                        }
                                        this.setState({photoCaptureForActivityArrNew:[...this.state.photoCaptureForActivityArrNew, obj]});
                                        this.setState({manualUploadImageNew:"Photo Upload Successfully..."});
                                    })
                                });
                        });
                }

                    

                
                   
    
    

              /* if(fileObj[0][i].type == "image/jpeg" || fileObj[0][i].type == "image/png" || fileObj[0][i].type == "image/jpg"){
                    this.toDataURL(URL.createObjectURL(fileObj[0][i]))
                    .then(dataUrl => {
                        var obj ={
                            fileId:getUID(),
                            fileType:fileObj[0][i].type,
                            data:dataUrl,
                        }
                        this.setState({photoCaptureForActivityArrNew:[...this.state.photoCaptureForActivityArrNew, obj]});
                        //this.setState({submitButtonDisabledForActivityNew:false});
                    });
                }

               /*const formData = new FormData();
                formData.append("img", fileObj[0][i]);
    
                this.setState({manualUploadImageNew:"Photo is Validating...Please wait"});
    
                await fetch( 'https://image.membershipengagements.com:8000/image/?use_model=true', {
                    method: "POST", 
                    body: formData
                  })
                  .then((response) => {
                    this.setState({manualUploadImageNew:""});
                    // 1. check response.ok
                    if (response.ok) {
                      return response.json();
                    }
                    //return Promise.reject(response); // 2. reject instead of throw
                  })
                  .then(responseData => {console.log(responseData); return responseData;})
                  .then((final_result) => {
                    console.log("image",Object.keys(final_result.result.bodylength).length)
                    console.log("image",final_result.result.bodylength.lengthAccepted)
    
                    // all good, token is ready
                    if(Object.keys(final_result.result.bodylength).length > 0){
                        //const isNameAvailable = final_result.result.detect_objs.find(item => item.name == 'person');
                        //console.log("isNameAvailable",isNameAvailable)
                        console.log("image",final_result.result.bodylength.lengthAccepted)
                        console.log("image",final_result.result.bodylength.reject_reason.length)
    
                        if(final_result.result.bodylength.lengthAccepted == true && final_result.result.bodylength.reject_reason.length == 0){
                            if(fileObj[0][i].type == "image/jpeg" || fileObj[0][i].type == "image/png" || fileObj[0][i].type == "image/jpg"){
                                this.toDataURL(URL.createObjectURL(fileObj[0][i]))
                                .then(dataUrl => {
                                    var obj ={
                                        fileId:getUID(),
                                        fileType:fileObj[0][i].type,
                                        data:dataUrl,
                                    }
                                    this.setState({photoCaptureForActivityArrNew:[...this.state.photoCaptureForActivityArrNew, obj]});
                                    //this.setState({submitButtonDisabledForActivityNew:false});
                                });
                            }
    
                            this.setState({manualUploadImageNew:"Photo Upload Successfully..."});
                        }else{
                            this.setState({manualUploadImageNew:"Please Upload Valid Photo...."});
                        }
                    }else{
                        this.setState({manualUploadImageNew:"Please Upload Valid Photoe...."});
                    }
                  })
                  .catch((response) => {
                    this.setState({manualUploadImageNew:"Please Upload Valid Photoee...."});
                    response.json().then((json) => {
                        this.setState({manualUploadImageNew:"Please Upload Valid Photoeee...."});
                    })
                  });*/
    
                
    
                  
              }
    
              
      }

  typeOfPhotoSeleted = (e,type) => {
    this.setState({
        capturePhotoModal:false,
        camaraRadioButtonNew:true,
        uploadImageRadioButtonNew:false,
        selectedTypePhotoNew:"camara",
        showActivityImgCaptureNew:true,
        manualUploadImageNew:"",
        photoCaptureForActivityArrNew:[],
        validateActivityImageUpload:"",
        validatePhotoCapture:"",
    });

    this.setState({photoSelectedType:type})
  }

  captureForActivityImageUploadNew = async () => {
    this.setState({photoCaptureForActivityArrNew:[]}); 
    this.setState({showActivityImgCaptureNew:true});


    const getUID = (length=8) => {
      var result           = '';
      var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var charactersLength = characters.length;
      for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    }

    var obj={
        fileId : getUID(),
        data : this.state.webcamRef.current.getScreenshot(),
      }

      this.setState({validateActivityImageUpload:"Photo is Validating...Please wait"});

      await fetch( 'https://www.mypartydashboard.com/BSA/WebService/validateImage', {
            method: "POST", 
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                "base64Str": this.state.webcamRef.current.getScreenshot().replace("data:image/jpeg;base64,","")
            }), 
        })
        .then((response) => {
          this.setState({validateActivityImageUpload:""});
          // 1. check response.ok
          if (response.ok) {
            return response.json();
          }
          //return Promise.reject(response); // 2. reject instead of throw
        })
        .then(responseData => {console.log(responseData); return responseData;})
        .then((final_result) => {
          // all good, token is ready
          console.log("image",Object.keys(final_result.result.bodylength).length)
          console.log("image",final_result.result.bodylength.lengthAccepted)

          // all good, token is ready
          if(Object.keys(final_result.result.bodylength).length > 0){
              //const isNameAvailable = final_result.result.detect_objs.find(item => item.name == 'person');
              //console.log("isNameAvailable",isNameAvailable)
              console.log("image",final_result.result.bodylength.lengthAccepted)
              console.log("image",final_result.result.bodylength.reject_reason.length)

              if(final_result.result.bodylength.lengthAccepted == true && final_result.result.bodylength.reject_reason.length == 0){
                  scroller.scrollTo("uploadBtnScrollCls", { 
                      duration: 800,
                      delay: 0,
                      smooth: "easeInOutQuart",
                  });
          
                    setTimeout(() => {
                        this.setState({photoCaptureForActivityArrNew:[...this.state.photoCaptureForActivityArrNew, obj]}); 
                        //this.setState({validateActivityImageUpload:""});
                    }, 500);

                  this.setState({validateActivityImageUpload:"Photo Capture Successfully..."});
              }else{
                  this.setState({validateActivityImageUpload:"Please Capture Valid Photo and Photo Should be in straight view"});
              }
          }else{
              this.setState({validateActivityImageUpload:"Please Capture Valid Photo and Photo Should be in straight view"});
          }
          
        })
        .catch((response) => {
            scroller.scrollTo("uploadBtnScrollCls", { 
                duration: 800,
                delay: 0,
                smooth: "easeInOutQuart",
            });
    
              setTimeout(() => {
                  this.setState({photoCaptureForActivityArrNew:[...this.state.photoCaptureForActivityArrNew, obj]}); 
                  //this.setState({validateActivityImageUpload:""});
              }, 500);

            this.setState({validateActivityImageUpload:"Photo Capture Successfully..."});
          response.json().then((json) => {
            scroller.scrollTo("uploadBtnScrollCls", { 
                duration: 800,
                delay: 0,
                smooth: "easeInOutQuart",
            });
    
              setTimeout(() => {
                  this.setState({photoCaptureForActivityArrNew:[...this.state.photoCaptureForActivityArrNew, obj]}); 
                  //this.setState({validateActivityImageUpload:""});
              }, 500);

            this.setState({validateActivityImageUpload:"Photo Capture Successfully..."});
          })
        });
        
        

      /*scroller.scrollTo("uploadBtnScrollCls", { 
                duration: 800,
                delay: 0,
                smooth: "easeInOutQuart",
            });

        setTimeout(() => {
            this.setState({photoCaptureForActivityArrNew:[...this.state.photoCaptureForActivityArrNew, obj]}); 
            this.setState({validateActivityImageUpload:""});
        }, 500);

       /*this.setState({validateActivityImageUpload:"Photo Capture Successfully..."});

           /* const byteString = atob(this.state.webcamRef.current.getScreenshot().split(",")[1]); // Decode base64 string
			const mimeString = this.state.webcamRef.current.getScreenshot().split(",")[0].split(":")[1].split(";")[0]; // Extract the mime type

			// Create a typed array from the byte string
			const byteArray = new Uint8Array(byteString.length);
			for (let i = 0; i < byteString.length; i++) {
				byteArray[i] = byteString.charCodeAt(i);
			}

			// Convert the byte array to a Blob
			const blob = new Blob([byteArray], { type: mimeString });

			// Convert Blob to a File object
			const final_file = new File([blob], "image.jpeg", { type: mimeString });

			const formData = new FormData();
			formData.append("img", final_file);

            this.setState({validateActivityImageUpload:"Photo is Validating...Please wait"});

			await fetch( 'https://www.mypartydashboard.com/BSA/WebService/validateImage', {
				method: "POST", 
				body: formData
			  })
			  .then((response) => {
                this.setState({validateActivityImageUpload:""});
				// 1. check response.ok
				if (response.ok) {
				  return response.json();
				}
				//return Promise.reject(response); // 2. reject instead of throw
			  })
              .then(responseData => {console.log(responseData); return responseData;})
			  .then((final_result) => {
				// all good, token is ready
                console.log("image",Object.keys(final_result.result.bodylength).length)
                console.log("image",final_result.result.bodylength.lengthAccepted)

				// all good, token is ready
				if(Object.keys(final_result.result.bodylength).length > 0){
					//const isNameAvailable = final_result.result.detect_objs.find(item => item.name == 'person');
					//console.log("isNameAvailable",isNameAvailable)
                    console.log("image",final_result.result.bodylength.lengthAccepted)
                    console.log("image",final_result.result.bodylength.reject_reason.length)

					if(final_result.result.bodylength.lengthAccepted == true && final_result.result.bodylength.reject_reason.length == 0){
						scroller.scrollTo("uploadBtnScrollCls", { 
                            duration: 800,
                            delay: 0,
                            smooth: "easeInOutQuart",
                        });
                
                    setTimeout(() => {
                        this.setState({photoCaptureForActivityArrNew:[...this.state.photoCaptureForActivityArrNew, obj]}); 
                        //this.setState({validateActivityImageUpload:""});
                    }, 500);

                        this.setState({validateActivityImageUpload:"Photo Capture Successfully..."});
					}else{
                        this.setState({validateActivityImageUpload:"Please Capture Valid Photo...."});
					}
				}else{
					this.setState({validateActivityImageUpload:"Please Capture Valid Photoe...."});
				}
				
			  })
			  .catch((response) => {
				this.setState({validateActivityImageUpload:"Please Capture Valid Photoe...."});
				response.json().then((json) => {
					this.setState({validateActivityImageUpload:"Please Capture Valid Photoee...."});
				})
			  });*/
    
   
    //this.setState({submitButtonDisabledForActivityNew:false});
};





paymentSelectType = (e,type) => {
    this.setState({regTypeInput:type})
}


saveCitVlorRegistration = () => {

    

    this.setState({successMessageEnroll:"",validatePersonDetails:"",validateNomineeDetails:"",validateNomineeReletion:"",
        validateCaptureMobileNo:"",validateCaptureOTP:"",validatePhotoCapture:"",validatePaymentMode:"",validateDonationAmount:"",validatePaymentOptionCheck:""});

   


   if(this.state.noVoterIdCheck == true){
        if(this.state.familyVoterIdName == "" || this.state.familyVoterIdName == 0){
            this.setState({validatePersonDetails:"Please Enter Person Details"});
            return;
        }
        if(this.state.familyVoterIdAge == "" || this.state.familyVoterIdAge == 0){
            this.setState({validatePersonDetails:"Please Enter Person Details"});
            return;
        }
        if(this.state.familyVoterIdGender == "" || this.state.familyVoterIdGender == 0){
            this.setState({validatePersonDetails:"Please Enter Person Details"});
            return;
        }

        console.log("asddd",this.state.familyVoterIdName,this.state.familyVoterIdGender,this.state.familyVoterIdAge)

        this.setState(Object.assign(this.state.newRegistrationInputObj,{cname: this.state.familyVoterIdName,
            gender:this.state.familyVoterIdGender,
            age:this.state.familyVoterIdAge}));

        
            
        
    }


    if(this.state.captureMobileNo == ""){
        scroller.scrollTo("scroll_top_mobile", { 
            duration: 800,
            delay: 0,
            smooth: "easeInOutQuart",
        });
        this.setState({validateCaptureMobileNo:"Please Enter Mobile No"});
        return;
    }
    if(!this.state.captureMobileNo.match(/^[0-9]+$/)){
        scroller.scrollTo("scroll_top_mobile", { 
            duration: 800,
            delay: 0,
            smooth: "easeInOutQuart",
        });
        this.setState({validateCaptureMobileNo:"Please Enter Valid Mobile No"});
        return;
    }

    if(this.state.captureMobileNo.length < 10){
        scroller.scrollTo("scroll_top_mobile", { 
            duration: 800,
            delay: 0,
            smooth: "easeInOutQuart",
        });
        this.setState({validateCaptureMobileNo:"Please Enter Valid Mobile No"});
        return;
    }

    if(this.state.isSkipOTP == "N"){
        if(this.state.captureMobileNo != ""){
            if(this.state.captureOTPNO == ""){
                scroller.scrollTo("scroll_top_mobile", { 
                    duration: 800,
                    delay: 0,
                    smooth: "easeInOutQuart",
                });
                this.setState({validateCaptureOTP:"Please Enter OTP"});
                return;
            }
    
            if(this.state.captureOTPNO.length < 6){
                scroller.scrollTo("scroll_top_mobile", { 
                    duration: 800,
                    delay: 0,
                    smooth: "easeInOutQuart",
                });
                this.setState({validateCaptureOTP:"Please Enter Valid OTP"});
                return;
            }
    
            if(this.state.otpVerifiedMessageStatus == "NotVerified"){
                scroller.scrollTo("scroll_top_mobile", { 
                    duration: 800,
                    delay: 0,
                    smooth: "easeInOutQuart",
                });
                this.setState({validateCaptureOTP:"Please Enter Valid OTP"});
                return;
            }
    
            
        }
    }
    

    this.setState(Object.assign(this.state.newRegistrationInputObj,{mobileNumber: this.state.captureMobileNo}));
    

    if(this.state.enrollType == "newEnroll"){
        if(this.state.familyNomineeSelectedBlock == true){

            const nomineeCheck  = this.state.familyDetailsArr.filter((item) => item.checked == true );
    
            if(nomineeCheck.length == 0){
                scroller.scrollTo("scroll_top_Nominee", { 
                    duration: 800,
                    delay: 0,
                    smooth: "easeInOutQuart",
                });
                this.setState({validateNomineeDetails:"Please Add Nominee Details"});
                return;
            }else{
                setTimeout(() => {
                    if(nomineeCheck.length>0){
                        for(var i in nomineeCheck){
                            if(nomineeCheck[i].checked == true){
                                
                                this.setState(Object.assign(this.state.newRegistrationInputObj,{fmName: nomineeCheck[i].personName,
                                    fmGender:nomineeCheck[i].gender,
                                    fmAge:nomineeCheck[i].age}));
    
                                
                            }
                        }
                    }
                }, 500);
    
                if(this.state.relationId == "" || this.state.relationId == 0){
                    scroller.scrollTo("scroll_top_Nominee", { 
                        duration: 800,
                        delay: 0,
                        smooth: "easeInOutQuart",
                    });
                    this.setState({validateNomineeReletion:"Please Select Nominee Reletion"});
                    return;
                }else{
    
                    this.setState(Object.assign(this.state.newRegistrationInputObj,{fmRelationId: this.state.relationId}));
    
                }
            }
            
        }else if(this.state.addNewNomineeSelectedBlock == true){
    
            if(this.state.newNomineeName == "" || this.state.newNomineeName == 0){
                scroller.scrollTo("scroll_top_Nominee", { 
                    duration: 800,
                    delay: 0,
                    smooth: "easeInOutQuart",
                });
                this.setState({validateNomineeDetails:"Please Add Nominee Details"});
                return;
            }
    
    
            if(this.state.newNomineeGender == "" || this.state.newNomineeGender == 0){
                scroller.scrollTo("scroll_top_Nominee", { 
                    duration: 800,
                    delay: 0,
                    smooth: "easeInOutQuart",
                });
                this.setState({validateNomineeDetails:"Please Add Nominee Details"});
                return;
            }
            if(this.state.newNomineeAge == "" || this.state.newNomineeAge == 0){
                scroller.scrollTo("scroll_top_Nominee", { 
                    duration: 800,
                    delay: 0,
                    smooth: "easeInOutQuart",
                });
                this.setState({validateNomineeDetails:"Please Add Nominee Details"});
                return;
            }
            if(this.state.newNomineeRelationId == "" || this.state.newNomineeRelationId == 0){
                scroller.scrollTo("scroll_top_Nominee", { 
                    duration: 800,
                    delay: 0,
                    smooth: "easeInOutQuart",
                });
                this.setState({validateNomineeDetails:"Please Add Nominee Details"});
                return;
            }
    
            this.setState(Object.assign(this.state.newRegistrationInputObj,{fmName: this.state.newNomineeName,
                fmGender:this.state.newNomineeGender,
                fmAge:this.state.newNomineeAge,
                fmRelationId: this.state.newNomineeRelationId}));
    
        }else if(this.state.useAsSameNomineeBlock == true){
    
            if(this.state.useSameNomineeName == "" || this.state.useSameNomineeName == 0){
                this.setState({validateNomineeDetails:"Please Enter Nominee Details"});
                return;
            }
            if(this.state.useSameNomineeGender == "" || this.state.useSameNomineeGender == 0){
                this.setState({validateNomineeDetails:"Please Enter Nominee Details"});
                return;
            }
            if(this.state.useSameNomineeAge == "" || this.state.useSameNomineeAge == 0){
                this.setState({validateNomineeDetails:"Please Enter Nominee Details"});
                return;
            }
            if(this.state.useSameNomineeRelation == "" || this.state.useSameNomineeRelation == 0){
                this.setState({validateNomineeDetails:"Please Enter Nominee Details"});
                return;
            }
    
            this.setState(Object.assign(this.state.newRegistrationInputObj,{fmName: this.state.useSameNomineeName,
                fmGender:this.state.useSameNomineeGender,
                fmAge:this.state.useSameNomineeAge,
                fmRelationId: this.state.useSameNomineeRelation}));
        }
    }
    

    if(this.state.photoSelectedType == "newPhoto"){
        if(this.state.selectedTypePhotoNew == "camara"){
            if(this.state.photoCaptureForActivityArrNew.length == 0){
                this.setState({validatePhotoCapture:"Please Take A Photo..."});
                return;
            }
        }else if(this.state.selectedTypePhotoNew == "upload"){
            if(this.state.photoCaptureForActivityArrNew.length == 0){
                this.setState({validatePhotoCapture:"Please Take A Photo..."});
                return;
            }
        }
    }else{
        this.setState(Object.assign(this.state.newRegistrationInputObj,{imageBase64String: ""}));
    }
    

    this.setState(Object.assign(this.state.newRegistrationInputObj,{volunteerMobileNo: this.state.volunteerMobileNoInput}));

   console.log("this.state.typeOfCardSelectedvalue",this.state.typeOfCardSelectedvalue)

   if(this.state.typeOfCardSelectedvalue == "lifeCardSelected"){
        this.setState(Object.assign(this.state.newRegistrationInputObj,{membershipType: "Permanent"}));
    }else{
        this.setState(Object.assign(this.state.newRegistrationInputObj,{membershipType: "General"}));
    }

   if(this.state.haveDonatePartyIdCheck == false && this.state.noDonatePartyIdCheck == false){
        this.setState({validatePaymentOptionCheck:"Do You Want Donate Please Click YES otherwise NO"});
        return;
    }else{
        if(this.state.haveDonatePartyIdCheck == true){
            this.setState(Object.assign(this.state.newRegistrationInputObj,{regType: "Online"}));
            if(this.state.donationAmountValue == "" || this.state.donationAmountValue == undefined || this.state.donationAmountValue == 0){
                this.setState({validateDonationAmount:"Please Enter Donaton Amount"});
                return;
            }

        }else if(this.state.noDonatePartyIdCheck == true){
            if(this.state.isVolunteer == "Y" ){
                if(this.state.regTypeInput == ""){
                    this.setState({validatePaymentMode:"Please Select Payment Mode Option"});
                    return;
                }

                this.setState(Object.assign(this.state.newRegistrationInputObj,{regType: this.state.regTypeInput}));
            }else{
                this.setState(Object.assign(this.state.newRegistrationInputObj,{regType: "Online"}));
            }
            
        }
    }

    this.setState(Object.assign(this.state.newRegistrationInputObj,{referralId: this.state.rederalMembershipId}));

    if(this.state.newRegistrationInputObj.fvid != 0 && this.state.noVoterIdCheck == true){
        this.setState(Object.assign(this.state.paymentGateWayInputDtsObj,{mobileNo:this.state.captureMobileNo,personName:this.state.familyVoterIdName,tdpCadreId:""}));
    
    }

    

    

    this.setState({redirectToPaymentMsg:""});

    console.log("sdffff",this.state.newRegistrationInputObj)
    console.log("dddddddddddd",this.state.paymentGateWayInputDtsObj)

    this.setState({saveEnrollLoadingSymbol:"show"});   

    this.setState({enrollSubmitButtonDisabled:true});
    

   setTimeout(() => {
    getAPICallDataForCadreSaving(JSON.stringify(this.state.newRegistrationInputObj),"saveCitVlorRegistrationByBot")
    .then((res) => res.json())
    .then((content) => {
        this.setState({saveEnrollLoadingSymbol:"hide"});  
        setTimeout(() => {
            this.setState({enrollSubmitButtonDisabled:false});
        }, 500);

        if(content !=null && content.saveStatus == "Success"){
            var imageStr="";
            if(this.state.photoCaptureForActivityArrNew.length > 0){
                for(var i in this.state.photoCaptureForActivityArrNew){
                    imageStr =  this.state.photoCaptureForActivityArrNew[i].data
                    
                }
            }

           
            this.setState(Object.assign(this.state.paymentGateWayInputDtsObj,{tdpCadreId:content.cardDetails.tcid,mobileNo:this.state.newRegistrationInputObj.mobileNumber}));


            if(this.state.regTypeInput == "Coupon" || this.state.regTypeInput == "Cash"){
                this.setState({enabledPayNowButtonForOnlinePayment:false})
                this.props.history.push({
                    pathname: "/display_card_success_page",
                    params: {
                        navbarDisplay:"hide",
                        englishSelected:this.state.englishSelected,
                        teleguSelected:this.state.teleguSelected,
                        tdpCadreStr:content.tcid
                    
                    },
                });

                this.setState({successMessageEnroll:"Your Application submitted Successfully",cardDetailsDisplay:content});
                setTimeout(() => {
                    this.setState({successMessageEnroll:""});

                }, 500);
            }else if(this.state.regTypeInput == "Online"){
                this.setState({enabledPayNowButtonForOnlinePayment:true})
                this.setState({redirectToPaymentMsg:"pay"});
                console.log("dddddddddddd",this.state.paymentGateWayInputDtsObj)
                this.startTransactionForIciciGateway();
                
                
            }else if(this.state.typeOfCardSelectedvalue == "lifeCardSelected"){
                this.setState({enabledPayNowButtonForOnlinePayment:true})
                this.setState({redirectToPaymentMsg:"pay"});
                console.log("dddddddddddd",this.state.paymentGateWayInputDtsObj)
                this.startTransactionForIciciGateway();
                
            }

            
        }else if(content !=null && content.saveStatus == "Already Registered"){
            this.setState({successMessageEnroll:content.saveStatus});
    
        }else if(content !=null && content.saveStatus == "Fail"){
            this.setState({successMessageEnroll:content.exceptionText});
    
        }else{
            this.setState({successMessageEnroll:"Some Thing Went Wrong,Please Try Again..."});
    
        }
    });
    }, 1000);

    

}


savePaymentPendingCitVlorByVolunteer = () => {


    this.setState({validatePaymentMode:"",validatePaymentOptionCheck:""});
    if(this.state.haveDonatePartyIdCheck == false && this.state.noDonatePartyIdCheck == false){
        this.setState({validatePaymentOptionCheck:"Do You Want Donate Please Click YES otherwise NO"});
        return;
    }else{
        if(this.state.haveDonatePartyIdCheck == true){
            if(this.state.donationAmountValue == "" || this.state.donationAmountValue == undefined || this.state.donationAmountValue == 0){
                this.setState({validateDonationAmount:"Please Enter Donaton Amount"});
                return;
            }

        }else if(this.state.noDonatePartyIdCheck == true){
            if(this.state.isVolunteer == "Y" ){
                if(this.state.regTypeInput == ""){
                    this.setState({validatePaymentMode:"Please Select Payment Mode Option"});
                    return;
                }

            }
            
        }
    }

    
    this.setState({saveEnrollPayLoadingSymbol:"show"});   

        
        this.setState({enrollSubmitPayButtonDisabled:true});

        const obj =  
            JSON.stringify({ 
                "cid" : this.state.tdpCadreId,
                "volunteerMobileNo" : this.state.volunteerMobileNoInput,
                "dataSourceType" : "TBot",
                "regType" : this.state.regTypeInput
            });
    
    setTimeout(() => {
        getAPICallDataForCadreSaving(obj,"savePaymentPendingCitVlorByVolunteer")
        .then((res) => res.json())
        .then((content) => {
            this.setState({saveEnrollPayLoadingSymbol:"hide"});  
            setTimeout(() => {
                this.setState({enrollSubmitPayButtonDisabled:false});
            }, 500);

            if(content !=null && content.status == "Success"){
            
                this.props.history.push({
                    pathname: "/display_card_success_page",
                    params: {
                        navbarDisplay:"hide",
                        englishSelected:this.state.englishSelected,
                        teleguSelected:this.state.teleguSelected,
                        tdpCadreStr:this.state.tdpCadreId
                    
                    },
                });

                this.setState({successMessagePayEnroll:"Your Application submitted Successfully",cardDetailsDisplay:content});
                setTimeout(() => {
                    this.setState({successMessagePayEnroll:""});

                }, 500);

                
            }if(content !=null && content.status == "Fail"){
                this.setState({successMessagePayEnroll:content.message});
        
            }else{
                this.setState({successMessagePayEnroll:"Some Thing Went Wrong,Please Try Again..."});
        
            }
        });
        }, 1000);


    
    

}


typeOfLanguageSelection = (e,languageType) => {
    this.setState({languageSelectionModal:false});

    if(languageType == "english"){
        this.setState({englishSelected:true,teleguSelected:false})
    }else{
        this.setState({englishSelected:false,teleguSelected:true})
    }
}

typeOfLanguageSelectionNew = (e,languageType) => {
   
    if(languageType == "english"){
        this.setState({englishSelected:true,teleguSelected:false})
    }else{
        this.setState({englishSelected:false,teleguSelected:true})
    }
}

paymentWithDonationPageWithVoterSerachNew = (mid) => {
    this.getDetailsForPaymentPendingWithVoterSearchNew("","",mid);
}


getDetailsForPaymentPendingWithVoterSearchNew = (mobileNo,vno,mid) => {
    

    const obj =  
        JSON.stringify({ 
            "mid" : mid,
            "mobileNo" : mobileNo,
            "vno" : vno,
            "constituencyId" : this.state.volunteerConstituencyInput,
            "username" : "app_api_cadre",
            "password" : "6Da3!p#w$5xqinRk"
        });

        getAPICallDataForCadre(obj,"getCitVlorSearchDetails")
        .then((res) => res.json())
        .then((content) => {
            if(content !=null && content.length>0){
                for(var i in content){
                    if(content[i].mid == mid){
                        this.paymentWithDonationPage(content[i].cname,content[i].cid,content[i].mobileNo,content[i].gender,content[i].age,content[i].membershipType)
                    }
                }
                
            }
        });
    
    
}

  paymentWithDonationPage = (personName,cid,mobileNo,gender,age,membershipType) => {
    this.setState({
            haveDonatePartyIdCheck:false,
            noDonatePartyIdCheck:false,
            otherDonationAmount:false,
            donationAmountValue:"",
            donationPanNumber:"",
            validatePanCardNumber:"",
            redirectToPaymentMsg:""
    });
   
    if(membershipType == "General"){
        this.setState({typeOfCardSelectedvalue:"generalCardSelected"})
    }else{
        this.setState({typeOfCardSelectedvalue:"lifeCardSelected"})
    }

    //this.setState({paymentGateWayInputDtsObj:{}});

    this.setState(Object.assign(this.state.paymentGateWayInputDtsObj,{mobileNo:mobileNo,personName:personName,tdpCadreId:cid}));

    
    var obj={
        "cname":personName,
        "gender":gender,
        "age":age,
        "membershipType":membershipType
        
    }

    this.setState({newRegistrationInputObj:obj});


    this.setState({newEnrollFirstPage:false,paymentWithDonationBlock:true,tdpCadreId:cid});

    console.log("this.state.paymentGateWayInputDtsObj",this.state.paymentGateWayInputDtsObj)
  }

  previousMemberShipTypeCls = () => {
    this.setState({newEnrollFirstPage:true,paymentWithDonationBlock:false});
  }

  haveDonateParty = (type) => {
    this.setState({validatePaymentMode:"",validatePaymentOptionCheck:""});
    this.setState({validateDonationAmount:""});
    if(type == "yes"){
        this.setState({haveDonatePartyIdCheck:true,noDonatePartyIdCheck:false,regTypeInput:"Online"})
    }else{
        this.setState({haveDonatePartyIdCheck:false,noDonatePartyIdCheck:true,regTypeInput:""})
    }
  }

  donationAmountSeletedType = (e,donAmount) => {
    this.setState({validateDonationAmount:""});
    if(donAmount == "other_amount"){
        this.setState({otherDonationAmount:true,donationAmountValue:""})
    }else{
        this.setState({otherDonationAmount:false,donationAmountValue:donAmount})
    }
  }

  haveMemberShipIdClick = (type) => {
    this.setState({
        
        renewalDetailsLoading:"hide",
        renewalDetailsArr:[],
        renewalDetailsDataCheck:0,

        
        searchRenewalMembershipId:"",
        searchRenewalMobileNo:"",
        searchRenewalVoterId:"",
        userDetailsError:"",

        donationName:"",
        donationGenderValue:"",
        donationGender:"",
        donationGenderArr:[{'value':'M','label':'Male'},{'value':"F",'label':'Female'}],
        donationAge:"",
        paynowDonationButtonDisabled:false,
        paynowDonationSuccessMessage:""
    })
    this.setState({donationFirstPage:true,donationSecondPage:false})
    if(type == "yes"){
        this.setState({haveMemberShipIdCheck:true,noMemberShipIdCheck:false})
    }else{
        this.setState({haveMemberShipIdCheck:false,noMemberShipIdCheck:true})
    }
  }

  donationSecondPageView = () => {
    this.setState({
        captureMobileNo:"",
        validateCaptureMobileNo:"",
        captureOTPNO:"",
        validateCaptureOTP:"",

        mobileNoDisabled:false,

        smsSentMessage:"",
        otpVerifiedMessageStatus:"",
        otpLoadingSymbol:"hide",
        getOTPLoadingSymbol:"hide",
        OTPSentStatus:"",
        resendOTPLoadingSymbol:"hide",
        resendSmsSentMessage:"",

        
        
        minutes:1,
        seconds:0,
        OTPVerifiedDisabledButton:true,
        donationAmountValue:"",
        paynowDonationButtonDisabled:false,
        paynowDonationSuccessMessage:""
    })
    this.setState({donationFirstPage:false,donationSecondPage:true})
  }

  donationPreviousPage = () => {
    this.setState({donationFirstPage:true,donationSecondPage:false})
  }

  paymentSuccessMessage = () => {
    this.setState({paynowDonationButtonDisabled:true,paynowDonationSuccessMessage:"Success"})

    setTimeout(() => {
       this.emptyFieldsSection();
    }, 1500);

   
  }

  backToNewCadreEnrollPage = () => {
    this.props.history.push({
        pathname: "/cadre_registration",
        params: {
            navbarDisplay:"hide",
           // userAccessList:this.props?.location?.params?.userAccessList == undefined ? "" : this.props?.location?.params?.userAccessList
          },
      });
}


sumitForm = () => {
    this.props.history.push({
        pathname: `/payment_success_page_my`,
        params: {
            navbarDisplay:"hide",
          },
      });
      
    
    
}

getParamsFromURL = (url) => {
    const urlObj = new URL(url);          // Create a new URL object
    const params = new URLSearchParams(urlObj.search); // Get the query string
  
    // Create an object to store the parameters
    const paramObj = {};
    
    // Iterate over all parameters and store them in the object
    for (const [key, value] of params.entries()) {
      paramObj[key] = value;
    }
  
    return paramObj;
  }

  changeToLifeTimeMembership = (personName,tdpCadreId,mobileNo) => {
    const queryParams = new URLSearchParams({
        "amount" : 100000,
        "mobileNo" : mobileNo,
        "source" : "TBot",
        "personName" : personName,
        "emailId" : "",
        "paymentModuleId" : 6,
        "tdpCadreId" : tdpCadreId,
        "panNumber" : "",
        "volunteerMobileNo" : this.state.volunteerMobileNoInput,
      }).toString();

      console.log("queryParams",queryParams)
  
      // Append query parameters to URL (replace `example.com` with your desired base URL)
      //http://tdp1.in/CR/WebService/PG/startTxnForIciciGateway?amount=1&mobileNo=9966542524&source=TBot&personName=Mahesh&emailId=maheshkommineni9@gmail.com&paymentModuleId=4&tdpCadreId=18507524&panNumber=APBHP2345H

      const url = `http://tdp1.in/CR/WebService/PG/startTxnForIciciGateway?${queryParams}`;
  
      // Redirect to the constructed URL (or use React Router for navigation)

     // setTimeout(() => {
        window.location.href = url;
  // }, 10000);
  }

startTransactionForIciciGateway = () => {
    //event.preventDefault();
    this.setState({validatePaymentMode:"",validatePaymentOptionCheck:""});
    if(this.state.haveDonatePartyIdCheck == false && this.state.noDonatePartyIdCheck == false){
        this.setState({validatePaymentOptionCheck:"Do you want to donate to the party...Please Click YES / NO"});
        return;
    }else{
        if(this.state.haveDonatePartyIdCheck == true){
            if(this.state.donationAmountValue == "" || this.state.donationAmountValue == undefined || this.state.donationAmountValue == 0){
                this.setState({validateDonationAmount:"Please Enter Donaton Amount"});
                return;
            }

        }else if(this.state.noDonatePartyIdCheck == true){
            if(this.state.isVolunteer == "Y" ){
                if(this.state.regTypeInput == ""){
                    this.setState({validatePaymentMode:"Please Select Payment Mode Option"});
                    return;
                }

            }
            
        }
    }

    
    var setAmount=0;
    var paymentModuleId=4;
    this.setState({validatePaymentOptionCheck:"",validateDonationAmount:"",validatePanCardNumber:"",validatePaymentMode:""});

    if(this.state.typeOfCardSelectedvalue == "lifeCardSelected"){
        if(this.state.haveDonatePartyIdCheck == true){
            if(this.state.donationAmountValue == "" || this.state.donationAmountValue == undefined || this.state.donationAmountValue == 0){
                this.setState({validateDonationAmount:"Please Enter Donaton Amount"});
                return;
            }

            setAmount =  parseInt(this.state.donationAmountValue)+100000;
        }else{
            setAmount = 100000;
            
        }
    }else{
        if(this.state.haveDonatePartyIdCheck == true){
            if(this.state.donationAmountValue == "" || this.state.donationAmountValue == undefined || this.state.donationAmountValue == 0){
                this.setState({validateDonationAmount:"Please Enter Donaton Amount"});
                return;
            }

            setAmount =  parseInt(this.state.donationAmountValue)+100;
        }else{
            setAmount = 100;
            
        }
    }
        
    
    this.setState({redirectToPaymentMsg:"pay"})


    const queryParams = new URLSearchParams({
        "amount" : setAmount,
        "mobileNo" : this.state.paymentGateWayInputDtsObj.mobileNo,
        "source" : "TBot",
        "personName" : this.state.paymentGateWayInputDtsObj.personName,
        "emailId" : "",
        "paymentModuleId" : paymentModuleId,
        "tdpCadreId" : this.state.paymentGateWayInputDtsObj.tdpCadreId,
        "panNumber" : this.state.donationPanNumber,
        "volunteerMobileNo" : this.state.volunteerMobileNoInput,
      }).toString();

      console.log("queryParams",queryParams)
  
      // Append query parameters to URL (replace `example.com` with your desired base URL)
      //http://tdp1.in/CR/WebService/PG/startTxnForIciciGateway?amount=1&mobileNo=9966542524&source=TBot&personName=Mahesh&emailId=maheshkommineni9@gmail.com&paymentModuleId=4&tdpCadreId=18507524&panNumber=APBHP2345H

      const url = `http://tdp1.in/CR/WebService/PG/startTxnForIciciGateway?${queryParams}`;
  
      // Redirect to the constructed URL (or use React Router for navigation)

     // setTimeout(() => {
        window.location.href = url;
  // }, 10000);
      


    /*const obj =  
        JSON.stringify({ 
            "amount" : 1,
            "mobileNo" : "9948029998",
            "source" : "TBot",
            "personName" : "AravindNaidu",
            "emailId" : "maheshkommineni9@gmail.com",
            "paymentModuleId" : 4,
            "tdpCadreId" : this.state.paymentGateWayInputDtsObj.tdpCadreId,
            "panNumber" : "ABCDE1234F"
        });

        getAPICallDataForPayment(obj,"startTransactionForIciciGateway")
        .then((res) => res.json())
        .then((content) => {
            if(content !=null){
                console.log("content.returnUrl",content.requestUrl)

                //setTimeout(() => {
                    window.location.href = content.requestUrl
               // }, 50000);

               
            }
        });*/

        //window.location.href = 'https://rizee.in/'
        
       /* const formBody = new URLSearchParams({
            "amount" : 1,
            "mobileNo" : "9948029998",
            "source" : "TBot",
            "personName" : "AravindNaidu",
            "emailId" : "maheshkommineni9@gmail.com",
            "paymentModuleId" : 4,
            "tdpCadreId" : this.state.paymentGateWayInputDtsObj.tdpCadreId,
            "panNumber" : "ABCDE1234F"
          }).toString();
      
          // Perform POST request with application/x-www-form-urlencoded content type
          fetch('https://www.mypartydashboard.com/CR/WebService/PG/startTxnForIciciGateway', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: formBody
          })
            .then((response) => response.json())
            .then((data) => {
              console.log('Success:', data);
              window.location.href = data.returnUrl
              
            })
            .catch((error) => {
              console.error('Error:', error);
            });*/

            

}

setDefaultImage = (img) => {
    img.src = "images/human.jpg";
}


    
    render() {
        
        console.log("newRegistrationInputObj",this.state.isSkipOTP)
       
        return (
            <section className="mb-4">
                <div className=''>
                    <Image variant="top" src={require('../../images/membership_logo.png')} className='w-100' />
                </div>

                {
                    this.state.isVolunteer != "Y" ?
                    (
                        <div className="bg_red_ass_coup1"></div>
                    )
                    :
                    (
                        <div className="bg_red_ass_coup color_white fw-bold f-14"> 
                            {this.state.volunterConstituencyName} ASSEMBLY
                            {
                                this.state.volunteerCouponsCount == 0 ?
                                (<span className='float-right'>Coupons Not Available</span>)
                                :
                                (<span className='float-right'>{this.state.volunteerCouponsCount} Coupons </span>)
                            }
                        </div>
                    )
                }

            <div className='bg_yellow_cadre'>   
            
              <Container className="mb-6">
                <Row>
                    <Col sm={12} className='mt-3'>
                    <div className='flex-back-lang'>
                        <div>
                            <Button variant="outline-danger pad5_14" className='f-12 fw-bold' onClick={() => this.backToNewCadreEnrollPage()}> <i class="fa-solid fa-arrow-left"></i> Home</Button> 
                        </div>
                        <div>
                            <Form>
                                <div className='float-end'>
                                <Form.Check
                                    inline
                                    label={`English Version`}
                                    name="languageSelectionNew"
                                    type="radio"
                                    id={`englishddVersionId`}
                                    onChange={(e)=>this.typeOfLanguageSelectionNew(e,"english")}
                                    className="f-12 fw-bold color_red cursor_pointer"
                                    value="english"
                                    checked={this.state.englishSelected}
                                />
                                <Form.Check
                                    inline
                                    label={`తెలుగు వెర్షన్`}
                                    name="languageSelectionNew"
                                    type="radio"
                                    id={`teleguddVersionId`}
                                    onChange={(e)=>this.typeOfLanguageSelectionNew(e,"telegu")}
                                    className="f-12 fw-bold color_red cursor_pointer"
                                    value="telegu"
                                    checked={this.state.teleguSelected}
                                />
                                </div>
                            </Form>
                        </div>
                    </div>
                    

                        
                            
                    </Col>
                </Row>

                {
                    this.state.registrationType == "general" ?
                    (
                        <Row>
                            <Col>
                                <h6 className='text-center color_green fw-bold  mt-3'> {this.state.englishSelected== true ? <span className='border-bottom-double'>GENERAL ENROLLMENT</span> : <span className='border-bottom-double'>సాధారణ నమోదు</span>}</h6>
                            </Col>
                        </Row>
                    )
                    :
                    (
                        <Row>
                            <Col>
                                <h6 className='text-center color_green fw-bold  mt-3'>{this.state.englishSelected== true ? <span className='border-bottom-double'>Life Time Membership</span> : <span className='border-bottom-double'>జీవితకాల సభ్యత్వం</span>}</h6>
                            </Col>
                        </Row>
                    )
                }
           
            

                <Row>
                    <Col sm={12}>
                        <Form>
                            <div className='mt-2 text-center'>
                            <Form.Check
                                inline
                                label={this.state.englishSelected== true ? `NEW ENROLLMENT` : `కొత్త సభ్యత్వం`}
                                name="cadreRegistrationType"
                                type="radio"
                                id={`newEnrollId`}
                                onChange={(e)=>this.enrollTypeRegister(e,"newEnroll")}
                                className="f-14 fw-bold color_black cursor_pointer"
                                defaultChecked={true}
                                value="newEnroll"
                            />
                            <Form.Check
                                inline
                                label={this.state.englishSelected== true ? `RENEWAL` : `పునరుద్ధరణ`}
                                name="cadreRegistrationType"
                                type="radio"
                                id={`renewalId`}
                                onChange={(e)=>this.enrollTypeRegister(e,"renewal")}
                                className="f-14 fw-bold color_black cursor_pointer"
                                value="renewal"
                            />
                            
                            </div>
                        </Form>
                            
                    </Col>
                </Row>

                <hr className='mb-1'/>

                {
                    this.state.enrollType == "newEnroll" ?
                    (
                        <>
                             {
                                this.state.newEnrollFirstPage == true ?
                                (
                                    <>
                                    <Row>
                                        <Col>
                                            <div className='bg_white_shadow_border mt-3'>
                                                <h6 className='text-center'>{this.state.englishSelected== true ? "Do You Have Your Voter Id?" : "మీకు మీ ఓటర్ ఐడి ఉందా?"}</h6>
                                                <Row >
                                                    <Col className='text-center mt-2'>
                                                        <Button variant="outline-success" className={this.state.haveVoterIdCheck == true ? "f-14 fw-bold active_checked" : "f-14 fw-bold"} onClick={() => this.haveVoterIdClick("yes")}> {this.state.englishSelected== true ? "YES" : "వుంది" } <i class="fa-solid fa-circle-check m_left_8"></i></Button>
                                                        <Button variant="outline-success" className={this.state.noVoterIdCheck == true ? "f-14 mr_10 fw-bold active_checked" : "f-14 mr_10 fw-bold"} onClick={() => this.haveVoterIdClick("no")}> {this.state.englishSelected== true ? "NO" : "లేదు" } <i class="fa-solid fa-circle-xmark m_left_8"></i></Button>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </Row>

                                    {
                                        this.state.haveVoterIdCheck == true || this.state.noVoterIdCheck == true ?
                                        (
                                            <fieldset class=""><legend>
                                                {
                                                    this.state.haveVoterIdCheck == true ?
                                                    (this.state.englishSelected== true ? "SEARCH BY OWN VOTER ID" : "స్వంత ఓటర్ ID ద్వారా శోధించండి")
                                                    :
                                                    (
                                                        this.state.noVoterIdCheck == true ?
                                                        (this.state.englishSelected== true ? "SEARCH BY FAMILY VOTER ID" : "కుటుంబ ఓటర్ ID ద్వారా శోధించండి")
                                                        :
                                                        ("")
                                                        
                                                    )
                                                }
                                                </legend>  

                                                {
                                                    this.state.haveVoterIdCheck == true ?
                                                    (
                                                        <>
                                                        <Row>
                                                            <Col>
                                                                <Form.Group  controlId="formVoterSerachCardNoId">
                                                                    <Form.Label className='f-12 fw-bold mb-0'>{this.state.englishSelected== true ? "Voter Card No" : "ఓటరు కార్డు నం"} </Form.Label>
                                                                    <Form.Control type="text" name="voterIdSearchVoterCardNo" value={this.state.voterIdSearchVoterCardNo} className='form-control-sm'  placeholder="Enter Voter Card No" onChange={(e) => this.handleOnchangeInputBox(e)}/>
                                                                </Form.Group>    
                                                            </Col>
                                                        </Row>

                                                            {
                                                                this.state.validateVoterIdSearch != "" ?
                                                                (
                                                                    <Row>
                                                                        <Col>
                                                                            <h6 className='error_cls_new mt-2'>{this.state.validateVoterIdSearch}</h6>
                                                                        </Col>
                                                                    </Row>
                                                                )
                                                                :
                                                                ("")
                                                            }

                                                            <Row>
                                                                <Col>
                                                                    <Button variant="dark" className='f-12 center-auto mt-2' onClick={() => this.getVoterDetailsByVoterCardNo()}>{this.state.englishSelected== true ? "GET VOTER" : "ఓటరు పొందండి"}</Button> 
                                                                </Col>
                                                            </Row>
                                                            
                                                            <div className='moveToPoint'></div>


                                                            </>
                                                    )
                                                    :
                                                    (
                                                        <>
                                                        <Row>
                                                            <Col>
                                                                <Form.Group  controlId="formVoterSerachCardNoId">
                                                                    <Form.Label className='f-12 fw-bold mb-0'>{this.state.englishSelected== true ? "Voter Card No" : "ఓటరు కార్డు నం"} </Form.Label>
                                                                    <Form.Control type="text" name="familyVoterIdSearch" value={this.state.familyVoterIdSearch} className='form-control-sm'  placeholder="Enter Voter Card No" onChange={(e) => this.handleOnchangeInputBox(e)}/>
                                                                </Form.Group>    
                                                            </Col>
                                                        </Row>

                                                        {
                                                                this.state.validateFamilyVoterIdSearch != "" ?
                                                                (
                                                                    <Row>
                                                                        <Col>
                                                                            <h6 className='error_cls_new mt-2'>{this.state.validateFamilyVoterIdSearch}</h6>
                                                                        </Col>
                                                                    </Row>
                                                                )
                                                                :
                                                                ("")
                                                            }

                                                        <Row>
                                                            <Col>
                                                                    <Button variant="dark" className='f-12 center-auto mt-2' onClick={() => this.getFamilyVoterDetailsByVoterCardNo()}>{this.state.englishSelected== true ? "GET VOTER" : "ఓటరు పొందండి"}</Button> 
                                                            </Col>
                                                        </Row>

                                                        </>
                                                    )
                                                }

                                                

                                            </fieldset>
                                        )
                                        :
                                        ("")
                                    }

                                    {
                                        this.state.haveVoterIdCheck == true ?
                                        (
                                            <>
                                            {
                                                this.state.voterIdSearchLoadingSymbol == "show" ?
                                                (
                                                    <Row>
                                                        <Col sm={12}>
                                                            <div class="spinner-border color_yellow loading-img-center mt-4"></div>
                                                        </Col>
                                                    </Row>
                                                )
                                                :
                                                ("")
                                            }
                                            {
                                                Object.keys(this.state.voterIdSearchDetailsObj).length > 0 ?
                                                (
                                                    
                                                    <>
                                                    <Row>
                                                        <Col>
                                                            <div className="border_yash_pad mt-3">
                                                                {
                                                                    this.state.voterIdSearchDetailsObj.personTeluguName != "" ?
                                                                    (<h6 className='f-14'>{this.state.englishSelected== true ? "Name" : "పేరు"} : {this.state.voterIdSearchDetailsObj.personTeluguName}</h6>)
                                                                    :
                                                                    (<h6 className='f-14'>{this.state.englishSelected== true ? "Name" : "పేరు"} : {this.state.voterIdSearchDetailsObj.personName}</h6>)
                                                                }
                                                                <h6 className='f-14 mt-2'>{this.state.englishSelected== true ? "Voter No" : "ఓటరు నెంబర్"}:{this.state.voterIdSearchDetailsObj.vno}</h6>
                                                                <h6 className='f-14 mt-2'>{this.state.englishSelected== true ? "Relative Name" : "బంధువు పేరు"}:{this.state.voterIdSearchDetailsObj.relativeName}</h6>
                                                                <h6 className='f-14 mt-2'>{this.state.englishSelected== true ? "H.NO" : "ఇంటి నెంబర్"}:{this.state.voterIdSearchDetailsObj.houseNo	}  |  {this.state.englishSelected== true ? "Gender" : "లింగం"} : {this.state.voterIdSearchDetailsObj.gender}  |  {this.state.englishSelected== true ? "Age" : "వయస్సు"} :{this.state.voterIdSearchDetailsObj.age}</h6>

                                                                <h6 className='f-14 mt-2'>{this.state.englishSelected== true ? "Enroll Status" : "నమోదు స్థితి"} :
                                                                    {
                                                                        this.state.voterIdSearchDetailsObj.enrollStatus == "Enrolled" ?
                                                                        (<span className='color_green fw-bold f-16'>{this.state.voterIdSearchDetailsObj.enrollStatus}</span>)
                                                                        :
                                                                        (
                                                                            this.state.voterIdSearchDetailsObj.enrollStatus == "Payment Pending" ?
                                                                            (<span className='color_red fw-bold f-16'>{this.state.voterIdSearchDetailsObj.enrollStatus}</span>)
                                                                            :
                                                                            (<span className='color_red fw-bold f-16'>{this.state.voterIdSearchDetailsObj.enrollStatus}</span>)
                                                                        )
                                                                    }
                                                                    
                                                                </h6>

                                                                {
                                                                    this.state.voterIdSearchDetailsObj.enrollStatus == "Enrolled" ? 
                                                                    (<h6 className='f-14 mt-2'>{this.state.englishSelected== true ? "MemberShip Type" : "సభ్యత్వం రకం"} : {this.state.voterIdSearchDetailsObj.membershipType}</h6>)
                                                                    :
                                                                    ("")
                                                                }

                                                                {
                                                                    this.state.voterIdSearchDetailsObj.cid != "" && this.state.voterIdSearchDetailsObj.mid != "" && this.state.voterIdSearchDetailsObj.enrollStatus	 == "Not Enrolled" ?
                                                                    (
                                                                        <h6 className='f-14 mt-3 fw-bold'>{this.state.englishSelected== true ? "This Person Previously Enrolled" : "ఈ వ్యక్తి గతంలో నమోదు చేసుకున్నాడు"} <span className='float-end text-decoration-underline color_anchor cursor_pointer' onClick={() => this.secondPageRenewalFromNewMemberShip(this.state.voterIdSearchDetailsObj)}>{this.state.englishSelected== true ? "Renewal Now" : "పునరుద్ధరణ కోసం"} </span></h6>
                                                                    )
                                                                    :
                                                                    (
                                                                        this.state.voterIdSearchDetailsObj.cid != "" && this.state.voterIdSearchDetailsObj.mid != "" && this.state.voterIdSearchDetailsObj.enrollStatus	 == "Enrolled" ?
                                                                        (
                                                                            <>
                                                                            <Row>
                                                                                <Col>
                                                                                    <h6 className='f-14 mt-3 fw-bold color_green text-center'>{this.state.englishSelected== true ? "This Person Already Enrolled" : "ఈ వ్యక్తి ఇప్పటికే నమోదు చేసుకున్నారు"} </h6>
                                                                                </Col>
                                                                            </Row>
                                                                            {
                                                                                this.state.voterIdSearchDetailsObj.membershipType == "General" ?
                                                                                (
                                                                                    <Row>
                                                                                        <Col>
                                                                                            <h6 className='float-end text-decoration-underline color_anchor cursor_pointer mt-2' onClick={() => this.changeToLifeTimeMembership(this.state.voterIdSearchDetailsObj.personName,this.state.voterIdSearchDetailsObj.cid,"")}>{this.state.englishSelected== true ? "Change To LifeTime Membership" : "జీవితకాల సభ్యత్వం కి మార్చుకోవాదము"} </h6>
                                                                                        </Col>
                                                                                    </Row>
                                                                                )
                                                                                :
                                                                                ("")
                                                                            }
                                                                            
                                                                            </>
                                                                            
                                                                            
                                                                        )
                                                                        :
                                                                        (
                                                                            this.state.voterIdSearchDetailsObj.cid == "" && this.state.voterIdSearchDetailsObj.mid == "" && this.state.voterIdSearchDetailsObj.enrollStatus	 == "Not Enrolled" ?
                                                                            (
                                                                                <Row>
                                                                                    <Col>
                                                                                        <h6 className='f-14 fw-bold float-end text-decoration-underline color_red cursor_pointer' onClick={() => this.secondPageNewMemberShip(this.state.voterIdSearchDetailsObj,"yes")}>{this.state.englishSelected== true ? "Enroll Now" : "కొత్త నమోదు కోసం "} </h6>
                                                                                    </Col>
                                                                                </Row>
                                                                            )
                                                                            :
                                                                            (
                                                                                this.state.voterIdSearchDetailsObj.enrollStatus	 == "Payment Pending" ?
                                                                                (
                                                                                    <Row>
                                                                                        <Col>
                                                                                           {/* <h6 className='f-14 fw-bold float-end text-decoration-underline color_red cursor_pointer' onClick={() => this.paymentWithDonationPage(this.state.voterIdSearchDetailsObj.personName,this.state.voterIdSearchDetailsObj.cid,"",this.state.voterIdSearchDetailsObj.gender,this.state.voterIdSearchDetailsObj.age,this.state.voterIdSearchDetailsObj.membershipType)} >Pay Now</h6>*/}
                                                                                           <h6 className='f-14 fw-bold float-end text-decoration-underline color_red cursor_pointer' onClick={() => this.paymentWithDonationPageWithVoterSerachNew(this.state.voterIdSearchDetailsObj.mid)} >Pay Now</h6>

                                                                                        </Col>
                                                                                    </Row>
                                                                                )
                                                                                :
                                                                                ("")
                                                                            )
                                                                            
                                                                            
                                                                        )
                                                                    )
                                                                }

                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    </>
                                                )
                                                :
                                                (<>
                                                    {
                                                    this.state.voterIdSearchDataCheck == 1 ?
                                                    (<h6 className='f-14 text-center mt-4'>Voter Id Not Available...</h6>)
                                                    :
                                                    ("")
                                                }
                                                </>)
                                            }
                                            </>
                                        )
                                        :
                                        (
                                            <>
                                            {
                                                this.state.familyVoterSearchLoading == "show" ?
                                                (
                                                    <Row>
                                                        <Col sm={12}>
                                                            <div class="spinner-border color_yellow loading-img-center mt-4"></div>
                                                        </Col>
                                                    </Row>
                                                )
                                                :
                                                ("")
                                            }
                                            {
                                                this.state.familyVoterSearchObj != "" ?
                                                (
                                                    
                                                    <>
                                                    <Row>
                                                        <Col>
                                                            <div className="border_yash_pad mt-3">
                                                                {
                                                                    this.state.familyVoterSearchObj.personTeluguName != "" ?
                                                                    (<h6 className='f-14'>{this.state.englishSelected== true ? "Name" : "పేరు"} : {this.state.familyVoterSearchObj.personTeluguName}</h6>)
                                                                    :
                                                                    (<h6 className='f-14'>Name : {this.state.familyVoterSearchObj.personName}</h6>)
                                                                }
                                                                <h6 className='f-14 mt-2'>{this.state.englishSelected== true ? "Voter No" : "ఓటరు నెంబర్"}:{this.state.familyVoterSearchObj.vno}</h6>
                                                                <h6 className='f-14 mt-2'>{this.state.englishSelected== true ? "Relative Name" : "బంధువు పేరు"}:{this.state.familyVoterSearchObj.relativeName}</h6>
                                                                <h6 className='f-14 mt-2'>{this.state.englishSelected== true ? "H.NO" : "ఇంటి నెంబర్"}:{this.state.familyVoterSearchObj.houseNo	}  |  {this.state.englishSelected== true ? "Gender" : "లింగం"} : {this.state.familyVoterSearchObj.gender}  |  {this.state.englishSelected== true ? "Age" : "వయస్సు"} :{this.state.familyVoterSearchObj.age}</h6>

                                                                

                                                                <Row>
                                                                    <Col>
                                                                        <h6 className='f-14 fw-bold float-end text-decoration-underline color_red cursor_pointer' onClick={() => this.secondPageNewMemberShip(this.state.familyVoterSearchObj,"no")}>{this.state.englishSelected== true ? "Enroll BY Using This Family Voter Id" : "ఈ కుటుంబ ఓటర్ ఐడిని ఉపయోగించి నమోదు చేయగలరు"} </h6>
                                                                    </Col>
                                                                </Row>

                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    </>
                                                )
                                                :
                                                (<>
                                                    {
                                                    this.state.familyVoterSearchDataCheck == 1 ?
                                                    (<h6 className='f-14 text-center mt-4'>No Data Availble...</h6>)
                                                    :
                                                    ("")
                                                }
                                                </>)
                                            }
                                            </>
                                        )
                                    }

                                        
                                        </>
                            
                                )
                                :
                                ("")
                            }
                        </>
                    )
                    :
                    (
                        this.state.enrollType == "renewal" ?
                        (
                            <>
                                {
                                    this.state.newEnrollFirstPage == true ?
                                    (
                                        <>
                                        <Row >
                                            <Col >
                                                <div className='mt-2 bg_white_shadow_border'>
                                                    <Col sm={12} className='mt-2'>
                                                        <label className="form-label form-label-block f-12 fw-bold">{this.state.englishSelected== true ? "MEMBERSHIP ID" : "సభ్యత్వ నెంబర్"} <span className='error_cls_new'>{this.state.validateSearchMemberShip}</span> </label>
                                                        <input type="text" className='form-control' name="searchRenewalMembershipId" placeholder='Enter MEMBERSHIP ID' maxLength={8} value={this.state.searchRenewalMembershipId} onChange={(e) => this.handleOnchangeInputBox(e)} onKeyUp={(e) => this.handleOnchangeAllowNumbersInputBox(e)} ></input>
                                                    </Col>
                                                    <Col sm={12} className='mt-2'>
                                                        <label className="form-label form-label-block f-12 fw-bold">(OR) {this.state.englishSelected== true ? "MOBILE NO" : "మొబైల్ నెంబర్"} </label>
                                                        <input type="text" className='form-control' name="searchRenewalMobileNo" placeholder='Enter MOBILE NO'maxLength={10} value={this.state.searchRenewalMobileNo} onChange={(e) => this.handleOnchangeInputBox(e)}></input>
                                                    </Col>
                                                    <Col sm={12} className='mt-2'>
                                                        <label className="form-label form-label-block f-12 fw-bold">(OR) {this.state.englishSelected== true ? "VOTER NO" : "ఓటరు నెంబర్"} </label>
                                                        <input type="text" className='form-control' name="searchRenewalVoterId" placeholder='Enter VOTER ID' value={this.state.searchRenewalVoterId} onChange={(e) => this.handleOnchangeInputBox(e)}></input>
                                                    </Col>
                                                    <p className='mt-1 f-12 error_cls_new'>{this.state.userDetailsError}</p>
                                                    <Button variant="success" className='f-18 fw-bold center-auto mt-2' size="lg" onClick={(e) => this.submitUserIds(e)} >{this.state.englishSelected== true ? "SUBMIT" : "SUBMIT"} </Button>

                                                </div>
                                            </Col>
                                        </Row>
                                        
                                            {
                                                this.state.renewalDetailsLoading == "show" ?
                                                (
                                                    <Row>
                                                        <Col sm={12}>
                                                            <div class="spinner-border color_yellow loading-img-center mt-4"></div>
                                                        </Col>
                                                    </Row>
                                                )
                                                :
                                                ("")
                                            }
                                            {
                                                this.state.renewalDetailsArr.length > 0 ?
                                                (
                                                    
                                                    <>
                                                    
                                                        {
                                                            this.state.renewalDetailsArr.map((item,index) => {
                                                                return(
                                                                    <Row>
                                                                        <Col>
                                                                            <div className="border_yash_pad mt-2">
                                                                                <h6 className='f-12'>{this.state.englishSelected== true ? "Name" : "పేరు"} : {item.cname}</h6>
                                                                                <h6 className='f-12'>{this.state.englishSelected== true ? "Membership No" : "సభ్యత్వం నెంబర్"}  : {item.mid}</h6>
                                                                                {
                                                                                    item.enrollStatus	 == "Payment Pending" ?
                                                                                    (<h6 className='f-12'>{this.state.englishSelected== true ? "MemberShip Type" : "సభ్యత్వం రకం"}  : {item.membershipType}</h6>)
                                                                                    :
                                                                                    ("")
                                                                                }
                                                                                
                                                                                <h6 className='f-12 mt-2'>{this.state.englishSelected== true ? "Voter No" : "ఓటరు నెంబర్"} : {item.vno}</h6>
                                                                                <h6 className='f-12 mt-2'>{this.state.englishSelected== true ? "Relative Name " : "బంధువు పేరు"}  : {item.relativeName} |  {this.state.englishSelected== true ? "Relation" : "సంబంధం"}  : {item.relation}</h6>
                                                                                <h6 className='f-12 mt-2'>{this.state.englishSelected== true ? "H.NO " : "ఇంటి నెంబర్"} :{item.houseNo}  |  {this.state.englishSelected== true ? "Gender " : "లింగం"} : {item.gender}  |  {this.state.englishSelected== true ? "Age " : "వయస్సు"} :{item.age}</h6>

                                                                                {
                                                                                        item.enrollStatus == "Enrolled" ? 
                                                                                        (<h6 className='f-12 mt-2'>{this.state.englishSelected== true ? "MemberShip Type" : "సభ్యత్వం రకం"} : {item.membershipType}</h6>)
                                                                                        :
                                                                                        ("")
                                                                                }
                                                                                {/*<h6 className='f-12 mt-2'>Enroll Status:
                                                                                    {
                                                                                        item.enrollStatus == "Enrolled" ?
                                                                                        (<span className='color_green fw-bold f-16'>{this.state.voterIdSearchDetailsObj.enrollStatus}</span>)
                                                                                        :
                                                                                        (
                                                                                            item.enrollStatus == "Payment Pending" ?
                                                                                            (<span className='color_red fw-bold f-16'>{item.enrollStatus}</span>)
                                                                                            :
                                                                                            (<span className='color_red fw-bold f-16'>{item.enrollStatus}</span>)
                                                                                        )
                                                                                    }
                                                                                    
                                                                                </h6>*/}

                                                                                {
                                                                                    item.enrollStatus	 == "Not Enrolled" ?
                                                                                    (
                                                                                        <Row>
                                                                                            <Col>
                                                                                                <h6 className='f-14 fw-bold float-end text-decoration-underline color_anchor cursor_pointer' onClick={() => this.secondPageRenewalMemberShip(item)}>{this.state.englishSelected== true ? "Renewal Now" : "పునరుద్ధరణ చేయండి"}</h6>
                                                                                            </Col>
                                                                                        </Row>
                                                                                    )
                                                                                    :
                                                                                    (
                                                                                        item.enrollStatus	 == "Enrolled" ?
                                                                                        (
                                                                                            <>
                                                                                            <Row>
                                                                                                <Col>
                                                                                                <h6 className='f-14 mt-2 fw-bold color_green text-center'>{this.state.englishSelected== true ? "This Person Already Registered" : "ఈ వ్యక్తి ఇప్పటికే నమోదు చేయబడ్డాడు"}</h6> 
                                                                                                </Col>
                                                                                            </Row>
                                                                                            {
                                                                                                item.membershipType == "General" ?
                                                                                                (
                                                                                                    <Row>
                                                                                                        <Col>
                                                                                                            <h6 className='float-end fw-bold text-decoration-underline color_anchor cursor_pointer mt-2' onClick={() => this.changeToLifeTimeMembership(item.cname,item.cid,item.mobileNo)}>{this.state.englishSelected== true ? "Change To LifeTime Membership" : "జీవితకాల సభ్యత్వం కి మార్చుకోవాదము"} </h6>
                                                                                                        </Col>
                                                                                                    </Row>
                                                                                                )
                                                                                                :
                                                                                                ("")
                                                                                            
                                                                                            }
                                                                                            
                                                                                            </>
                                                                                            
                                                                                            
                                                                                        )
                                                                                        :
                                                                                        (
                                                                                            item.enrollStatus	 == "Payment Pending" ?
                                                                                            (
                                                                                                <Row>
                                                                                                    <Col>
                                                                                                        <h6 className='f-14 fw-bold float-end text-decoration-underline color_red cursor_pointer' onClick={() => this.paymentWithDonationPage(item.cname,item.cid,item.mobileNo,item.gender,item.age,item.membershipType)}>Pay Now</h6>
                                                                                                    </Col>
                                                                                                </Row>
                                                                                            )
                                                                                            :
                                                                                            (
                                                                                                ""
                                                                                            )
                                                                                            
                                                                                            
                                                                                        )
                                                                                    )
                                                                                }

                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                )
                                                                
                                                            })
                                                        }
                                                        
                                                    </>
                                                )
                                                :
                                                (<>
                                                    {
                                                    this.state.renewalDetailsDataCheck == 1 ?
                                                    (<h6 className='f-14 text-center mt-4'>No Data Availble...</h6>)
                                                    :
                                                    ("")
                                                }
                                                </>)
                                            }
                                                    
                                            </>
                                    )
                                    :
                                    (
                                        ""
                                    )
                                }
                            </>
                        )
                        :
                        (
                            this.state.enrollType == "donation" ?
                            (
                                <DonationAmount
                                    stateData={this.state}
                                    paymentSuccessMessage={this.paymentSuccessMessage}
                                    handleOnchangeInputBox={this.handleOnchangeInputBox}
                                    donationAmountSeletedType={this.donationAmountSeletedType}
                                    getMobileNoOTP={this.getMobileNoOTP}
                                    resendOTPNew={this.resendOTPNew}
                                    donationPreviousPage={this.donationPreviousPage}
                                    donationSecondPageView={this.donationSecondPageView}
                                    handleOnchangeSelectBoxNew={this.handleOnchangeSelectBoxNew}
                                    submitUserIds={this.submitUserIds}
                                    haveMemberShipIdClick={this.haveMemberShipIdClick}
                                />
                            )
                            :
                            ("")
                        )
                    )
                }

               
                {/* Donation Code End */}



                {
                    this.state.newEnrollSecondPage == true ?
                    (
                        <>
                        <div className='scroll_top_mobile'></div>
                        <Row>
                            <Col>
                                <Button variant="outline-dark pad5_14" className='f-12 fw-bold float-end mt-2' onClick={() => this.previousFirstPageNewMemberShip()}> <i class="fa-solid fa-arrow-left"></i> Back</Button> 
                            </Col>
                        </Row>

                        

                        {
                            this.state.noVoterIdCheck == true ? 
                            (
                                <fieldset class=""><legend> {this.state.englishSelected== true ? "Your Family Selected Person" : "మీ కుటుంబం నుంచీ ఎంచుకున్న వ్యక్తి"}</legend> 
                                    <Row>
                                        <Col>
                                            <h6 className='f-12'>{this.state.englishSelected== true ? "Name" : "పేరు"} : {this.state.newRegistrationInputObj.cname}</h6>
                                            <h6 className='f-12 mt-2'> {this.state.englishSelected== true ? "Gender " : "లింగం"} : {this.state.newRegistrationInputObj.gender}  |  {this.state.englishSelected== true ? "Age " : "వయస్సు"} :{this.state.newRegistrationInputObj.age}</h6>
                                    </Col>
                                    </Row> 
                                </fieldset>
                            )
                            :
                            (
                                <fieldset class=""><legend> {this.state.englishSelected== true ? "Your Selected Person" : "మీరు ఎంచుకున్న వ్యక్తి"}</legend> 
                                    <Row>
                                        <Col>
                                            <h6 className='f-12'>{this.state.englishSelected== true ? "Name" : "పేరు"} : {this.state.newRegistrationInputObj.cname}</h6>
                                            <h6 className='f-12 mt-2'> {this.state.englishSelected== true ? "Gender " : "లింగం"} : {this.state.newRegistrationInputObj.gender}  |  {this.state.englishSelected== true ? "Age " : "వయస్సు"} :{this.state.newRegistrationInputObj.age}</h6>
                                    </Col>
                                    </Row> 
                                </fieldset>
                            )
                        }

                        {
                            this.state.noVoterIdCheck == true ?
                            (
                                <fieldset class=""><legend>{this.state.englishSelected== true ? "Enter Person Details" : "వ్యక్తి వివరాలను నమోదు చేయండి"}  </legend> 
                                     <Row>
                                            <Col className='mt-2'>
                                                <h6 className="form-label f-14 fw-bold"> {this.state.englishSelected== true ? "Name" : "పేరు"} <span className='color_red f-14 ms-1'>*</span> <span className='color_red f-12 ms-1'>{this.state.validatefamilyVoterIdName}</span></h6>
                                                <Form.Control type="text" name="familyVoterIdName" value={this.state.familyVoterIdName}  className='form-control-sm'  placeholder="Enter Name" onKeyUp={(e) => this.handleOnchangeAllowNumbersInputBox(e)} onChange={(e) => this.handleOnchangeInputBox(e)}/>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col className='mt-2'>
                                                <h6 className="form-label f-14 fw-bold"> {this.state.englishSelected== true ? "Gender" : "లింగం"} <span className='color_red f-14 ms-1'>*</span></h6>
                                                <SelectBox
                                                    stateData={this.state.familyVoterIdGenderValue}
                                                    handleChange={this.handleOnchangeSelectBoxNew}
                                                    name="familyVoterIdGender"
                                                    options={this.state.familyVoterIdGenderArr}
                                                    placeholderName={'Gender'}
                                                    dropdownIndicator={{ DropdownIndicator }}
                                                />

                                               
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col className='mt-2'>
                                                <h6 className="form-label f-14 fw-bold"> {this.state.englishSelected== true ? "Age" : "వయస్సు"} <span className='color_red f-14 ms-1'>*</span> <span className='color_red f-12 ms-1'>{this.state.validatefamilyVoterIdAge}</span></h6>
                                                <Form.Control type="text" name="familyVoterIdAge" value={this.state.familyVoterIdAge} className='form-control-sm' maxLength={2} placeholder="Enter Age" onKeyUp={(e) => this.handleOnchangeAllowNumbersInputBox(e)} onChange={(e) => this.handleOnchangeInputBox(e)}/>
                                            </Col>
                                        </Row>

                                        {
                                            this.state.validatePersonDetails != "" ?
                                            (
                                                <Row>
                                                    <Col sm={12}>
                                                        <h6 className='error_cls_new'>{this.state.validatePersonDetails}</h6>
                                                    </Col>
                                                </Row>
                                            )
                                            :
                                            ("")
                                        }
                                </fieldset>
                            )
                            :
                            ("")
                        }

                        
                      
                        

                        
                        
                        

                        <ChangeMobileNoOTPValidation 
                                stateData={this.state}
                                handleOnchangeInputBox={this.handleOnchangeInputBox}
                                getMobileNoOTP={this.getMobileNoOTP}
                                resendOTPNew={this.resendOTPNew}
                                handleOnchangeAllowNumbersInputBox={this.handleOnchangeAllowNumbersInputBox}
                                changeMobileNo={this.changeMobileNo}
                            />

                        <div className='scroll_top_Nominee'></div>
                        {
                            this.state.enrollType == "newEnroll" ?
                            (
                                <fieldset class=""><legend> {this.state.englishSelected== true ? "Add Nominee" : "నామినీ జోడించండి"}</legend>  
                                
                                    {
                                            this.state.enrollType == "renewal" || this.state.enrollType == "renewalfromNew" ?
                                            (
                                                <>
                                                    <Row>
                                                        <Col>
                                                            <div className="">
                                                                <Form.Check
                                                                        inline
                                                                        label={this.state.englishSelected== true ? `Use Existing Nominee` : `ఇప్పటికే ఉన్న నామినీని ఉపయోగగించుకోవచ్చు` }
                                                                        name="nomineeDetailsType"
                                                                        type="radio"
                                                                        id={`useAsSameNomineeId`}
                                                                        className="f-12 fw-bold color_black cursor_pointer"
                                                                        value="sameNominee"
                                                                        defaultChecked={true}
                                                                        onChange={(e)=>this.typeOfNominneeSeleted(e,"sameNominee")}
                                                                ></Form.Check>
                                                            
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    
                                                    <h6 className='text-center f-12'>(OR)</h6>
                                                    </>
                                                )
                                                :
                                                ("")
                                            }
                                            <Row>
                                                <Col>
                                                    <div className="">
                                                        <Form.Check
                                                                inline
                                                                label={this.state.englishSelected== true ?  "New Nominee" : "కొత్త నామినీ ని నమోదు చేయండి"}
                                                                name="nomineeDetailsType"
                                                                type="radio"
                                                                id={`addNewNomineeId`}
                                                                className="f-12 fw-bold color_black cursor_pointer"
                                                                value="newNominee"
                                                                onChange={(e)=>this.typeOfNominneeSeleted(e,"newNominee")}
                                                        ></Form.Check>
                                                        <Form.Check
                                                                inline
                                                                label={this.state.englishSelected== true ? "Select Nominee From Family" : "కుటుంబం నుండి నామినీని ఎంచుకోండి"}
                                                                name="nomineeDetailsType"
                                                                type="radio"
                                                                id={`nomineeFromFamilyId`}
                                                                className="f-12 fw-bold color_black cursor_pointer"
                                                                value="family"
                                                                defaultChecked={this.state.enrollType == "newEnroll" ? true : false}
                                                                onChange={(e)=>this.typeOfNominneeSeleted(e,"family")}
                                                        ></Form.Check>
                                                    </div>
                                                </Col>
                                            </Row>

                                            {
                                                this.state.validateNomineeDetails != "" ?
                                                (
                                                    <Row>
                                                        <Col sm={12}>
                                                            <h6 className='error_cls_new'>{this.state.validateNomineeDetails}</h6>
                                                        </Col>
                                                    </Row>
                                                )
                                                :
                                                ("")
                                            }

                                            {
                                                this.state.familyNomineeSelectedBlock == true ?
                                                (
                                                    <>
                                                        {
                                                            this.state.familyDetailsLoading == "show" ?
                                                            (
                                                                <Row>
                                                                    <Col sm={12}>
                                                                        <div class="spinner-border color_yellow loading-img-center mt-4"></div>
                                                                    </Col>
                                                                </Row>
                                                            )
                                                            :
                                                            ("")
                                                        }
                                                        {
                                                            this.state.familyDetailsArr.length > 0 ?
                                                            (
                                                                
                                                                <>
                                                                <Row>
                                                                    <Col>
                                                                    <div className='collapse-cls'>
                                                                        <h6 className='mt-2 f-14' onClick={() => this.familyDetailsOpenClick()}>{this.state.englishSelected== true ? "Family Details" : "కుటుంబ వివరాలు"} 
                                                                            <span className='float-end'>
                                                                                {
                                                                                this.state.familyDetailsOpenBlock == false ?
                                                                                (<i className="fa-solid fa-square-plus"></i>)
                                                                                :
                                                                                (<i className="fa-solid fa-square-minus"></i>)
                                                                                }
                                                                                
                                                                                </span>
                                                                            </h6>
                                                                            <Collapse in={this.state.familyDetailsOpenBlock}>
                                                                                <div className='bg_light_blue mt-3'>
                                                                                    <CardLessDataTableWithSearchLimit10 
                                                                                        parentData={this.familyDetailsDisplayData()}
                                                                                        particlecolumns={this.familyDetailsDisplayColumns()}
                                                                                        defaultSorted={[{
                                                                                            dataField: "Age",
                                                                                            order: "desc"
                                                                                        }]}
                                                                                        tableHeading=""
                                                                                        />
                                                                                    
                                                                                        
                                                                                </div>
                                                                            </Collapse>
                                                                    </div>
                                                                    
                                                                    </Col>
                                                                </Row>

                                                                {
                                                                    Object.keys(this.state.newRegistrationInputObj).length > 0 ?
                                                                    (
                                                                        this.state.newRegistrationInputObj.fmName != "" ?
                                                                        (
                                                                            <Row>
                                                                                <Col>
                                                                                    <div className='border_yash_pad mt-3'>
                                                                                        <h6 className='f-12 fw-bold'>{this.state.englishSelected== true ? "Selected Nominnee Details" : "ఎంపిక చేయబడిన నామినీ వివరాలు"}   : </h6>
                                                                                        <h6 className='f-14 mt-3'>{this.state.englishSelected== true ? "Name" : "పేరు"}:{this.state.newRegistrationInputObj.fmName}</h6>
                                                                                        <h6 className='f-14 mt-2'>{this.state.englishSelected== true ? "Gender" : "లింగం"} : {this.state.newRegistrationInputObj.fmGender}  |  {this.state.englishSelected== true ? "Age" : "వయస్సు"} :{this.state.newRegistrationInputObj.fmAge}</h6>

                                                                                        <Row>
                                                                                            <Col className='mt-2'>
                                                                                            <label className="form-label f-12 fw-bold">{this.state.englishSelected== true ? "Relation" : "సంబంధం"} </label>
                                                                                            <SelectBox
                                                                                                stateData={this.state.relationValue}
                                                                                                handleChange={this.handleOnchangeSelectBoxNew}
                                                                                                name="relationId"
                                                                                                options={this.state.relationListArray}
                                                                                                placeholderName={'Select relation'}
                                                                                                dropdownIndicator={{ DropdownIndicator }}
                                                                                            /> 

                                                                                        {
                                                                                            this.state.validateNomineeReletion != "" ?
                                                                                            (
                                                                                                <h6 className='error_cls_new'>{this.state.validateNomineeReletion}</h6>
                                                                                            )
                                                                                            :
                                                                                            ("")
                                                                                        }

                                                                                            </Col>
                                                                                        </Row>
                                                                                        
                                                                                    </div>
                                                                                </Col>
                                                                            </Row>
                                                                        )
                                                                        :
                                                                        ("")
                                                                    )
                                                                    :
                                                                    ("")
                                                                }
                                                                
                                                                
                                                                </>
                                                            )
                                                            :
                                                            (<>
                                                                {
                                                                this.state.familyDetailsDataCheck == 1 ?
                                                                (<h6 className='f-14 text-center mt-4'>No Data Availble...</h6>)
                                                                :
                                                                ("")
                                                            }
                                                            </>)
                                                        }
                                                        </>
                                                )
                                                :
                                                (
                                                    this.state.addNewNomineeSelectedBlock == true ? 
                                                    (
                                                        <>
                                                    <Row>
                                                        <Col className='mt-2'>
                                                            <h6 className="form-label f-14 fw-bold"> {this.state.englishSelected== true ? "Name" : "పేరు"} <span className='color_red f-14 ms-1'>*</span> <span className='color_red f-12 ms-1'>{this.state.validatenewNomineeName}</span></h6>
                                                            <Form.Control type="text" name="newNomineeName"  className='form-control-sm' value={this.state.newNomineeName}  placeholder="Enter Name" onKeyUp={(e) => this.handleOnchangeAllowNumbersInputBox(e)} onChange={(e) => this.handleOnchangeInputBox(e)}/>
                                                        </Col>
                                                    </Row>

                                                    

                                                    <Row>
                                                        <Col className='mt-2'>
                                                            <h6 className="form-label f-14 fw-bold"> {this.state.englishSelected== true ? "Gender" : "లింగం"} <span className='color_red f-14 ms-1'>*</span></h6>
                                                            <SelectBox
                                                                stateData={this.state.newNomineeGenderValue}
                                                                handleChange={this.handleOnchangeSelectBoxNew}
                                                                name="newNomineeGender"
                                                                options={this.state.newNomineeGenderArr}
                                                                placeholderName={'Gender'}
                                                                dropdownIndicator={{ DropdownIndicator }}
                                                            />

                                                        
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col className='mt-2'>
                                                            <h6 className="form-label f-14 fw-bold"> {this.state.englishSelected== true ? "Age" : "వయస్సు"} <span className='color_red f-14 ms-1'>*</span> <span className='color_red f-12 ms-1'>{this.state.validatenewNomineeAge}</span></h6>
                                                            <Form.Control type="text" name="newNomineeAge"  className='form-control-sm'  placeholder="Enter Age" maxLength={2} onKeyUp={(e) => this.handleOnchangeAllowNumbersInputBox(e)} onChange={(e) => this.handleOnchangeInputBox(e)}/>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col className='mt-2'>
                                                        <label className="form-label f-12 fw-bold">{this.state.englishSelected== true ? "Relation" : "సంబంధం"} <span className='color_red f-14 ms-1'>*</span></label>
                                                        <SelectBox
                                                            stateData={this.state.newNomineeRelationValue}
                                                            handleChange={this.handleOnchangeSelectBoxNew}
                                                            name="newNomineeRelationId"
                                                            options={this.state.newNomineeRelationListArray}
                                                            placeholderName={'Select relation'}
                                                            dropdownIndicator={{ DropdownIndicator }}
                                                        /> 

                                                        </Col>
                                                    </Row>
                                                    </>
                                                    )
                                                    :
                                                    (
                                                        this.state.useAsSameNomineeBlock == true ? 
                                                        (
                                                        <>
                                                        <Row>
                                                                <Col className='mt-2'>
                                                                    <h6 className="form-label f-14 fw-bold"> {this.state.englishSelected== true ? "Name" : "పేరు"} <span className='color_red f-14 ms-1'>*</span></h6>
                                                                    <Form.Control type="text" name="useSameNomineeName" value={this.state.useSameNomineeName}  className='form-control-sm'  placeholder="Enter Name" onChange={(e) => this.handleOnchangeInputBox(e)}/>
                                                                </Col>
                                                            </Row>

                                                            

                                                            <Row>
                                                                <Col className='mt-2'>
                                                                    <h6 className="form-label f-14 fw-bold"> {this.state.englishSelected== true ? "Gender" : "లింగం"} <span className='color_red f-14 ms-1'>*</span></h6>
                                                                    <SelectBox
                                                                        stateData={this.state.useSameNomineeGenderValue}
                                                                        handleChange={this.handleOnchangeSelectBoxNew}
                                                                        name="useSameNomineeGender"
                                                                        options={this.state.useSameNomineeGenderArr}
                                                                        placeholderName={'Gender'}
                                                                        dropdownIndicator={{ DropdownIndicator }}
                                                                    />

                                                                
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col className='mt-2'>
                                                                    <h6 className="form-label f-14 fw-bold"> {this.state.englishSelected== true ? "Age" : "వయస్సు"} <span className='color_red f-14 ms-1'>*</span></h6>
                                                                    <Form.Control type="text" name="useSameNomineeAge" value={this.state.useSameNomineeAge}  className='form-control-sm'  placeholder="Enter Age" maxLength={2}  onChange={(e) => this.handleOnchangeInputBox(e)}/>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col className='mt-2'>
                                                                <label className="form-label f-12 fw-bold">{this.state.englishSelected== true ? "Relation" : "సంబంధం"} <span className='color_red f-14 ms-1'>*</span></label>
                                                                <SelectBox
                                                                    stateData={this.state.useSameNomineeRelationValue}
                                                                    handleChange={this.handleOnchangeSelectBoxNew}
                                                                    name="useSameNomineeRelation"
                                                                    options={this.state.useSameNomineeRelationArr}
                                                                    placeholderName={'Select relation'}
                                                                    dropdownIndicator={{ DropdownIndicator }}
                                                                /> 

                                                                </Col>
                                                            </Row>
                                                            </>
                                                        )
                                                        :
                                                        ("")
                                                    )
                                                )
                                            }
                                    </fieldset>
                            )
                            :
                            ("")
                        }


                            <fieldset class=""><legend> {this.state.englishSelected== true ? "PHOTO" : "ఫోటో"}</legend>  
                                    <Row>
                                        <Col>
                                            <div className="">
                                                {
                                                    this.state.newRegistrationInputObj.imageStatus == "Y" ?
                                                    (
                                                        <Form.Check
                                                                inline
                                                                label={this.state.englishSelected== true ?  "Use Existing Photo" : "ఇప్పటికే ఉన్న ఫోటోని ఉపయోగించండి"}
                                                                name="photoCaptureName"
                                                                type="radio"
                                                                id={`useExistingPhotoId`}
                                                                className="f-12 fw-bold color_black cursor_pointer"
                                                                value="useExistingPhoto"
                                                                defaultChecked={this.state.newRegistrationInputObj.imageStatus == "Y" ? true : false}
                                                                onChange={(e)=>this.typeOfPhotoSeleted(e,"useExistingPhoto")}
                                                        ></Form.Check>
                                                    )
                                                    :
                                                    ("")
                                                }
                                                
                                                <Form.Check
                                                        inline
                                                        label={this.state.englishSelected== true ? "New Photo" : "కొత్త ఫోటో తీయండి"}
                                                        name="photoCaptureName"
                                                        type="radio"
                                                        id={`newPhotoId`}
                                                        className="f-12 fw-bold color_black cursor_pointer"
                                                        value="newPhoto"
                                                        defaultChecked={this.state.newRegistrationInputObj.imageStatus == "" ? true : false}
                                                        onChange={(e)=>this.typeOfPhotoSeleted(e,"newPhoto")}
                                                ></Form.Check>
                                            </div>
                                        </Col>
                                    </Row>

                                    {
                                        this.state.photoSelectedType == "useExistingPhoto" ? 
                                        (
                                            <Row>
                                                    <Col sm={12} className="">
                                                    <div className='flex_img'>
                                                        <div className='ms-1 border_img_pad'>
                                                            <img src={this.state.newRegistrationInputObj.imageUrl}  onError={({ currentTarget }) => {currentTarget.onerror = null; currentTarget.src=require('../../images/human.jpg');}} className='img-thumbnail' alt="captureImg"></img>
                                                        </div> 
                                                    </div>
                                                </Col>
                                            </Row>
                                        )
                                        :
                                        (
                                            <Row>
                                                <Col>
                                                    <div className='bg_white_shadow_border mt-2'>
                                                    <h6 className='f-14 fw-bold text-center'>{this.state.englishSelected== true ? "TAKE A PHOTO" : "ఫోటో తీయండి"}  <i class="fa-solid fa-camera color_green f-28 cursor_pointer m_left_8 pos_top4" onClick={() => this.capturePhotoForCadreEnroll()}></i> </h6>
                                                        {
                                                            this.state.validatePhotoCapture != "" ?
                                                            (<h6 className='error_cls_new'>{this.state.validatePhotoCapture}</h6>)
                                                            :
                                                            ("")
                                                        }
                                                            <Row>
                                                                <Col sm={12} className="">
                                                                <div className='flex_img'>
                                                                    {(this.state.photoCaptureForActivityArrNew || []).map((url,index) => (
                                                                        <div className='ms-1 border_img_pad'>
                                                                            <img src={url.data} className='img-thumbnail' alt="captureImg"></img>
                                                                        </div>
                                                                    ))} 
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Col>
                                            </Row>
                                        )
                                    }

                                </fieldset>

                                <fieldset class=""><legend> {this.state.englishSelected== true ? "Referral Membership Number" : "రిఫరల్ మెంబర్షిప్ నెంబర్"}</legend> 
                                    <Row>
                                        <Col>
                                            <input type="text" className='form-control' name="rederalMembershipId" placeholder='Enter Referral Membership No' maxLength={8} value={this.state.rederalMembershipId} onChange={(e) => this.handleOnchangeInputBox(e)} ></input>
                                        </Col>
                                    </Row>  
                                </fieldset>

                            
                            {/*
                                this.state.registrationType == "general" ?
                                (
                                    <CardselectedType
                                        stateData={this.state}
                                        cardSelectedType={this.cardSelectedType}
                                        paymentPendingOption=""
                                    />
                                )
                                :
                                ("")
                           */ } 

                             <CardselectedType
                                stateData={this.state}
                                cardSelectedType={this.cardSelectedType}
                                paymentPendingOption=""
                            />  

                            <PaymentOptionMode
                                    stateData={this.state}
                                    paymentSelectType={this.paymentSelectType}
                                    haveDonateParty={this.haveDonateParty}
                                    donationAmountSeletedType={this.donationAmountSeletedType}
                                    handleOnchangeInputBox={this.handleOnchangeInputBox}
                                    handleOnchangeAllowNumbersInputBox={this.handleOnchangeAllowNumbersInputBox}
                                /> 
                            

                        

                        {/*
                            this.state.typeOfCardSelectedvalue == "generalCardSelected" ?
                            (
                                <>
                                

                                <PaymentOptionMode
                                    stateData={this.state}
                                    paymentSelectType={this.paymentSelectType}
                                    haveDonateParty={this.haveDonateParty}
                                    donationAmountSeletedType={this.donationAmountSeletedType}
                                    handleOnchangeInputBox={this.handleOnchangeInputBox}
                                    handleOnchangeAllowNumbersInputBox={this.handleOnchangeAllowNumbersInputBox}
                                />

                                </>
                            )
                            :
                            (
                                <>
                                    {
                                        this.state.registrationType == "lifeTime" ? 
                                        (
                                            <Row>
                                                <Col>
                                                    <h6 className='color_red mt-2 f-14'>{this.state.englishSelected== true ? "Your Selected Life Time Membership Card" : "మీరు జీవితకాల సభ్యత్వం  ఎంచుకున్నారు"} </h6>
                                                    <h6 className='color_red mt-2 f-14'>{this.state.englishSelected== true ? "Amount Rs 100000/-" : " Amount Rs 100000/-"} </h6>
                                                </Col>
                                            </Row>
                                        )
                                        :
                                        ("")
                                    }
                                </>
                                
                            )
                       */ }

                       

                        

                           <>
                                {
                                    this.state.redirectToPaymentMsg != "" ?
                                    (
                                        <Row>
                                            <Col>
                                                <h6 className='color_red mt-2 text-center'>Redirect To Payment Page,Please Wait....</h6>
                                            </Col>
                                        </Row>
                                    )
                                    :
                                    ("")
                                }

                                {
                                    this.state.enabledPayNowButtonForOnlinePayment == false ? 
                                    (
                                    <Row>
                                        <Col sm={12}>
                                        
                                            {
                                                this.state.successMessageEnroll == "Your Application submitted Successfully" ?
                                                (<h6 className='text-center f-14 color_green mt-5 fw-bold'>{this.state.successMessageEnroll}</h6>)
                                                :
                                                (
                                                    this.state.successMessageEnroll == "Already Registered" ?
                                                    (<h6 className='text-center f-14 color_green mt-5 fw-bold ln-22'>{this.state.successMessageEnroll}</h6>)
                                                    :
                                                    (<h6 className='text-center f-14 color_red mt-5 fw-bold ln-22'>{this.state.successMessageEnroll}</h6>)
                                                    
                                                )
                                            }

                                            <Button variant="danger" className="red_button_event center-auto mt-3" disabled={this.state.enrollSubmitButtonDisabled} onClick={() => this.saveCitVlorRegistration()}>PAY NOW
                                            
                                                {
                                                    this.state.saveEnrollLoadingSymbol == "show" ? 
                                                    (<Image src={loader} alt="loader" className='loader_cls ms-2'></Image>)
                                                    :
                                                    ("")
                                                }
                                            </Button>
                                            

                                            
                                            
                                        </Col>
                                    </Row>
                                )
                                    :
                                    ("")
                                }


                                

                            </>



                        
                        </>
                    ):("")
                }


                {
                    this.state.paymentWithDonationBlock == true ?
                    (
                        <>
                            <Row>
                                <Col>
                                    <Button variant="outline-dark pad5_14" className='f-12 fw-bold float-end mt-2' onClick={() => this.previousFirstPageNewMemberShipPAYButton()}> <i class="fa-solid fa-arrow-left"></i> Back</Button> 
                                </Col>
                            </Row>

                            <fieldset class=""><legend> {this.state.englishSelected== true ? "Your Selected Person" : "మీరు ఎంచుకున్న వ్యక్తి"}</legend> 
                                <Row>
                                    <Col>
                                        <h6 className='f-12'>{this.state.englishSelected== true ? "Name" : "పేరు"} : {this.state.newRegistrationInputObj.cname}</h6>
                                        <h6 className='f-12 mt-2'>{this.state.englishSelected== true ? "MemberShip Type" : "సభ్యత్వం రకం"} : {this.state.newRegistrationInputObj.membershipType}</h6>
                                        <h6 className='f-12 mt-2'> {this.state.englishSelected== true ? "Gender " : "లింగం"} : {this.state.newRegistrationInputObj.gender}  |  {this.state.englishSelected== true ? "Age " : "వయస్సు"} :{this.state.newRegistrationInputObj.age}</h6>
                                </Col>
                                </Row> 
                            </fieldset>

                           
                            <CardselectedType
                                stateData={this.state}
                                cardSelectedType={this.cardSelectedType}
                                paymentPendingOption="paymentPending"
                            /> 

                                <PaymentOptionMode
                                    stateData={this.state}
                                    paymentSelectType={this.paymentSelectType}
                                    haveDonateParty={this.haveDonateParty}
                                    donationAmountSeletedType={this.donationAmountSeletedType}
                                    handleOnchangeInputBox={this.handleOnchangeInputBox}
                                    handleOnchangeAllowNumbersInputBox={this.handleOnchangeAllowNumbersInputBox}
                                />

                                {
                                    this.state.isVolunteer == 'Y' ?
                                    (
                                        <>

{
                                        this.state.regTypeInput == "Online" ?
                                        (
                                            <>
                                            {
                                                this.state.redirectToPaymentMsg != "" ?
                                                (
                                                    <Row>
                                                        <Col>
                                                            <h6 className='color_red mt-2 text-center'>Redirect To Payment Page,Please Wait....</h6>
                                                        </Col>
                                                    </Row>
                                                )
                                                :
                                                ("")
                                            }
                                            
                                            <Button variant="danger" className="red_button_event center-auto mt-3" onClick={() => this.startTransactionForIciciGateway()}>PAY NOW </Button>
                                            </>
                                        )
                                        :
                                        (
                                            <Row>
                                                <Col sm={12}>
                                                    <Button variant="danger" className="red_button_event center-auto mt-3" disabled={this.state.enrollSubmitPayButtonDisabled} onClick={() => this.savePaymentPendingCitVlorByVolunteer()}>PAY NOW </Button>

                                                    {
                                                        this.state.saveEnrollPayLoadingSymbol == "show" ? 
                                                        (<Image src={loader} alt="loader" className='loader_cls ms-2'></Image>)
                                                        :
                                                        ("")
                                                    }
                                                    {
                                                        this.state.successMessagePayEnroll == "Your Application submitted Successfully" ?
                                                        (<h6 className='text-center f-14 color_green mt-5 fw-bold'>{this.state.successMessagePayEnroll}</h6>)
                                                        :
                                                        (
                                                            <h6 className='text-center f-14 color_red mt-5 fw-bold ln-22'>{this.state.successMessagePayEnroll}</h6>
                                                            
                                                        )
                                                    }
                                                </Col>
                                            </Row>
                                        )
                                    }

                                        </>
                                    )
                                    :
                                    (
                                        <>
                                        {
                                            this.state.redirectToPaymentMsg != "" ?
                                            (
                                                <Row>
                                                    <Col>
                                                        <h6 className='color_red mt-2 text-center'>Redirect To Payment Page,Please Wait....</h6>
                                                    </Col>
                                                </Row>
                                            )
                                            :
                                            ("")
                                        }
                                        <Button variant="danger" className="red_button_event center-auto mt-3" onClick={() => this.startTransactionForIciciGateway()}>PAY NOW </Button>
                                        </>
                                    )
                                }
                        
                        </>
                    )
                    :
                    ("")
                }

                
               

            </Container>
            </div>

            <CapturePhotoForEnroll
                        show={this.state.capturePhotoModal}
                        onHide={() => this.setState({ capturePhotoModal: false })}
                        stateData={this.state}
                        uploadMultipleFilesForPhotosNew={this.uploadMultipleFilesForPhotosNew}
                        uploadImageForMembership={this.uploadImageForMembership}
                        captureForActivityImageUploadNew={this.captureForActivityImageUploadNew}
                        selectCaptureTypeNew={this.selectCaptureTypeNew}
                />

                
                
        </section>
        )
    }
  }
  
  export default withRouter(CadreRegistrationGeneralSection);
  